document.addEventListener('DOMContentLoaded', function() {

  // Track page load time to prevent initial tooltips
  window.pageLoadTime = Date.now();
  
  // Function to update all selection displays
  function updateSelectionDisplays() {
    // Update size display
    const sizeDisplay = document.getElementById('selectedSizeDisplay');
    const activeSizeOption = document.querySelector('.size-option.active');
    if (sizeDisplay) {
      if (activeSizeOption) {
        sizeDisplay.textContent = activeSizeOption.dataset.size || activeSizeOption.dataset.label || 'Selected';
      } else {
        sizeDisplay.textContent = '';
      }
    }
    
    // Update color display
    const colorDisplay = document.getElementById('selectedColorDisplay');
    const activeColorOption = document.querySelector('.color-circle.active');
    if (colorDisplay) {
      if (activeColorOption) {
        colorDisplay.textContent = activeColorOption.dataset.color || activeColorOption.dataset.label || 'Selected';
      } else {
        colorDisplay.textContent = '';
      }
    }
    
    // Update lock display
    const lockDisplay = document.getElementById('selectedLockDisplay');
    const activeLockOption = document.querySelector('.lock-option.active');
    if (lockDisplay) {
      if (activeLockOption) {
        lockDisplay.textContent = activeLockOption.dataset.lock || activeLockOption.dataset.label || 'Selected';
      } else {
        lockDisplay.textContent = '';
      }
    }
    
    // Update upgrade display
    const upgradeDisplay = document.getElementById('selectedUpgradeDisplay');
    const activeUpgradeOption = document.querySelector('#upgradeOptions .upgrade-option.active, .upgrade-option.active');
    if (upgradeDisplay) {
      if (activeUpgradeOption) {
        const displayText = activeUpgradeOption.dataset.displayText || activeUpgradeOption.dataset.upgrade || 'Selected';
        upgradeDisplay.textContent = displayText;
      } else {
        upgradeDisplay.textContent = '';
      }
    }
    
    // Update lock upgrade display
    const lockUpgradeDisplay = document.getElementById('selectedLockUpgradeDisplay');
    const activeLockUpgradeOption = document.querySelector('#lockUpgradeOptions .upgrade-option.active');
    if (lockUpgradeDisplay) {
      if (activeLockUpgradeOption) {
        const displayText = activeLockUpgradeOption.dataset.displayText || activeLockUpgradeOption.dataset.upgrade || 'Selected';
        lockUpgradeDisplay.textContent = displayText;
      } else {
        lockUpgradeDisplay.textContent = '';
      }
    }
  }
  
  // Make the function globally accessible
  window.updateSelectionDisplays = updateSelectionDisplays;
  
  // Initialize tooltips
  initTooltips();
  
  // Initialize sticky cart
  initStickyCart();
  
  // Debug function for testing tooltips
  window.debugTooltips = function() {
    const allElements = document.querySelectorAll('[data-tooltip]');
    
    allElements.forEach((el, i) => {
      console.log(`${i + 1}. ${el.tagName}.${el.className}`, {
        dataTooltip: el.getAttribute('data-tooltip'),
        hasTooltipDiv: !!el.querySelector('.tooltip'),
        computedPointerEvents: window.getComputedStyle(el).pointerEvents,
        computedZIndex: window.getComputedStyle(el).zIndex
      });
    });
    
    const glossElements = document.querySelectorAll('.color-circle[data-color*="gloss" i]');
    const lockElements = document.querySelectorAll('.lock-option');
    
  };
  
  // Auto-run debug after a short delay
  setTimeout(() => {
    window.debugTooltips();
  }, 2000);
  
  // Wait for the gallery system to initialize before setting up custom variant selection
  setTimeout(initializeCustomVariantSelection, 500);
});

// Global mobile device detection function
function isMobileDevice() {
  // Use multiple checks for better accuracy
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  const isSmallScreen = window.innerWidth <= 768;
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  
  // Only consider it mobile if it has touch AND is a small screen AND matches mobile user agent
  const isMobile = hasTouch && isSmallScreen && isMobileUA;
  
  console.log('Mobile device detection:', {
    hasTouch,
    isSmallScreen,
    isMobileUA,
    finalDecision: isMobile
  });
  
  return isMobile;
}

function initTooltips() {
  // Check if we're on a mobile device using more accurate detection
  
  if (isMobileDevice()) {
    return;
  }
  
  // Remove global tooltip if it exists (we'll use individual tooltips)
  const globalTooltip = document.getElementById("tooltip");
  if (globalTooltip) {
    globalTooltip.remove();
  }
  
  const tooltipElements = document.querySelectorAll("[data-tooltip]");
  
  // Debug: Log what elements we found
  tooltipElements.forEach((el, index) => {
    console.log(`Element ${index}:`, {
      className: el.className,
      dataTooltip: el.getAttribute('data-tooltip'),
      tagName: el.tagName,
      isGloss: el.getAttribute('data-color') && el.getAttribute('data-color').toLowerCase().includes('gloss'),
      isLock: el.classList.contains('lock-option')
    });
  });

  tooltipElements.forEach((element) => {
    // Instead of creating tooltip inside the element, create it in the document body
    // and position it absolutely relative to the viewport
    let tooltip = document.getElementById(`tooltip-${element.className.replace(/\s+/g, '-')}-${Math.random().toString(36).substr(2, 9)}`);
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'tooltip';
      tooltip.id = `tooltip-${element.className.replace(/\s+/g, '-')}-${Math.random().toString(36).substr(2, 9)}`;
      // Append to body instead of inside the element
      document.body.appendChild(tooltip);
    }

    // Clear any existing event listeners
    element.onmouseenter = null;
    element.onmouseleave = null;

    // Use direct event handler assignment for maximum compatibility
    element.onmouseenter = function(e) {
      // Don't show tooltip immediately on page load - add a small delay to prevent initial tooltips
      if (Date.now() - window.pageLoadTime < 3000) {
        return;
      }
      
      
      const tooltipText = this.getAttribute('data-tooltip');
      if (!tooltipText) {
        return;
      }
      
      tooltip.textContent = tooltipText;
      tooltip.classList.add("visible");
      
      // Position tooltip relative to the viewport, above the element
      const rect = this.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      
      // Position above the element
      const left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
      const top = rect.top - tooltipRect.height - 10;
      
      // Make sure tooltip doesn't go outside viewport
      const finalLeft = Math.max(10, Math.min(left, window.innerWidth - tooltipRect.width - 10));
      const finalTop = Math.max(10, top);
      
      tooltip.style.position = 'fixed';
      tooltip.style.left = finalLeft + 'px';
      tooltip.style.top = finalTop + 'px';
      tooltip.style.zIndex = '99999';

    };

    element.onmouseleave = function(e) {
      tooltip.classList.remove("visible");
    };

    // Special handling for problematic elements
    if (element.classList.contains('color-circle') || element.classList.contains('lock-option')) {
      
      // Force pointer events
      element.style.pointerEvents = 'auto';
      element.style.position = 'relative';
      element.style.zIndex = '10';
      
      // For gloss circles, ensure tooltip is really high
      if (element.getAttribute('data-color') && 
          element.getAttribute('data-color').toLowerCase().includes('gloss')) {
        tooltip.style.zIndex = '100000';
      }
    }
  });

  // Additional debug: Test if we can find specific elements
  const glossCircles = document.querySelectorAll('.color-circle[data-color*="gloss" i]');
  const lockOptions = document.querySelectorAll('.lock-option');
}

function initStickyCart() {
  const stickyCart = document.getElementById("sticky-cart");
  const mainAddToCart = document.getElementById("addToCartBtn"); // Use the actual button ID
  const jumpToTopBtn = document.getElementById("jump-to-top");
  const productSection = document.querySelector(".product_section");

  if (!stickyCart || !mainAddToCart) {
    return;
  }

  // Check if main button is visible
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyCart.classList.remove("visible");
        } else {
          stickyCart.classList.add("visible");
        }
      });
    },
    { threshold: 0.1 }
  );

  observer.observe(mainAddToCart);

  // Check if user has scrolled past the product section for jump to top button
  const jumpToTopObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (jumpToTopBtn) {
          if (entry.isIntersecting) {
            // User is in the product section - hide jump to top
            jumpToTopBtn.style.display = "none";
          } else {
            // User has scrolled past the product section - show jump to top
            jumpToTopBtn.style.display = "flex";
          }
        }
      });
    },
    { 
      threshold: 0.1,
      rootMargin: "0px 0px 50px 0px" // Show button slightly before completely leaving section
    }
  );

  if (productSection && jumpToTopBtn) {
    jumpToTopObserver.observe(productSection);
  }

  // Add click handler for sticky cart button
  const stickyButton = document.getElementById("sticky-add-to-cart");
  if (stickyButton) {
    stickyButton.addEventListener('click', function() {
      // Trigger the main add to cart button
      mainAddToCart.click();
    });
  }

  // Add click handler for jump to top button
  if (jumpToTopBtn) {
    jumpToTopBtn.addEventListener('click', function() {
      // Scroll to the main add to cart button smoothly
      mainAddToCart.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center',
        inline: 'nearest'
      });
    });
  }
}

function initializeCustomVariantSelection() {
  // Initialize Lucide icons
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  }

  // Initialize mobile carousel for key features with a slight delay to ensure DOM is ready
  setTimeout(() => {
    initializeKeyFeaturesCarousel();
  }, 100);

  // Get product data
  const productJsonElement = document.getElementById('product-json');
  let productData = null;
  
  if (productJsonElement) {
    try {
      productData = JSON.parse(productJsonElement.textContent);
    } catch (e) {
      console.error('Error parsing product JSON:', e);
    }
  }

  if (!productData) {
    console.error('Product data not found');
    return;
  }

// Mobile carousel functionality for key features
function initializeKeyFeaturesCarousel() {
  const keyFeaturesContainer = document.querySelector('.key-features');
  const keyFeaturesWrapper = document.querySelector('.key-features-wrapper');
  
  // Check if elements exist and if we're on mobile
  if (!keyFeaturesContainer || !keyFeaturesWrapper) {
    return;
  }
  
  // Function to check if we're on mobile
  function isMobile() {
    return window.innerWidth <= 767;
  }
  
  if (!isMobile()) {
    return; // Only initialize on mobile
  }

  // Remove any existing indicators first
  const existingIndicators = keyFeaturesWrapper.querySelector('.carousel-indicators');
  if (existingIndicators) {
    existingIndicators.remove();
  }

  const features = keyFeaturesContainer.querySelectorAll('.feature-item');
  const totalFeatures = features.length;
  
  if (totalFeatures <= 2) {
    return; // No need for carousel if 2 or fewer features
  }

  // Calculate number of pages (showing 2 features per page)
  const totalPages = Math.ceil(totalFeatures / 2);
  let currentPage = 0;
  let autoplayInterval;
  
  // Only create indicators if we have more than 1 page
  if (totalPages > 1) {
    // Create carousel indicators
    const indicatorsContainer = document.createElement('div');
    indicatorsContainer.className = 'carousel-indicators';
    
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('div');
      dot.className = `carousel-dot ${i === 0 ? 'active' : ''}`;
      dot.addEventListener('click', () => {
        stopAutoplay();
        scrollToPage(i);
        startAutoplay();
      });
      indicatorsContainer.appendChild(dot);
    }
    
    keyFeaturesWrapper.appendChild(indicatorsContainer);
  }

  // Scroll to specific page
  function scrollToPage(pageIndex) {
    currentPage = pageIndex;
    
    // Get container width and calculate scroll position more accurately
    const containerWidth = keyFeaturesContainer.offsetWidth;
    const gap = 15; // Gap between items as defined in CSS
    
    // Each feature is 50% width minus half the gap
    const featureWidth = (containerWidth - gap) / 2;
    
    // Each page scrolls by the width of 2 features plus the gap between them
    const scrollPosition = pageIndex * containerWidth;
    
    console.log(`Scrolling to page ${pageIndex}:`, {
      containerWidth,
      featureWidth,
      scrollPosition,
      currentScrollLeft: keyFeaturesContainer.scrollLeft
    });
    
    keyFeaturesContainer.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
    
    // Update active indicator
    updateActiveIndicator(pageIndex);
  }

  // Update active indicator
  function updateActiveIndicator(pageIndex) {
    const indicatorsContainer = document.querySelector('.carousel-indicators');
    if (indicatorsContainer) {
      const dots = indicatorsContainer.querySelectorAll('.carousel-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === pageIndex);
      });
    }
  }

  // Start autoplay
  function startAutoplay() {
    stopAutoplay(); // Clear any existing interval
    autoplayInterval = setInterval(() => {
      const nextPage = (currentPage + 1) % totalPages;
      scrollToPage(nextPage);
    }, 6000); // 6 seconds
  }

  // Stop autoplay
  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Handle scroll events to update indicators
  let scrollTimeout;
  keyFeaturesContainer.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const containerWidth = keyFeaturesContainer.offsetWidth;
      const scrollLeft = keyFeaturesContainer.scrollLeft;
      
      // Calculate which page we're on
      const calculatedPage = Math.round(scrollLeft / containerWidth);
      const newPage = Math.max(0, Math.min(calculatedPage, totalPages - 1));
      
      if (newPage !== currentPage) {
        currentPage = newPage;
        updateActiveIndicator(currentPage);
      }
      
    }, 100);
  });

  // Handle touch/swipe gestures
  let startX = 0;
  let scrollStart = 0;
  let isDragging = false;

  keyFeaturesContainer.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    scrollStart = keyFeaturesContainer.scrollLeft;
    isDragging = false;
    stopAutoplay(); // Stop autoplay when user interacts
  });

  keyFeaturesContainer.addEventListener('touchmove', function(e) {
    if (!startX) return;
    
    isDragging = true;
    const currentX = e.touches[0].clientX;
    const diffX = startX - currentX;
    keyFeaturesContainer.scrollLeft = scrollStart + diffX;
  });

  keyFeaturesContainer.addEventListener('touchend', function() {
    if (!startX || !isDragging) {
      startAutoplay(); // Resume autoplay
      return;
    }
    
    // Calculate which page we should snap to
    const containerWidth = keyFeaturesContainer.offsetWidth;
    const scrollLeft = keyFeaturesContainer.scrollLeft;
    const nearestPage = Math.round(scrollLeft / containerWidth);
    
    
    scrollToPage(Math.max(0, Math.min(nearestPage, totalPages - 1)));
    
    startX = 0;
    scrollStart = 0;
    isDragging = false;
    
    // Resume autoplay after interaction
    setTimeout(() => {
      startAutoplay();
    }, 1000);
  });

  // Pause autoplay on hover/focus
  keyFeaturesContainer.addEventListener('mouseenter', stopAutoplay);
  keyFeaturesContainer.addEventListener('mouseleave', startAutoplay);

  // Initialize to show first page (features 1 and 2)
  function initializeCarousel() {
    // Ensure we start at the beginning
    keyFeaturesContainer.scrollLeft = 0;
    currentPage = 0;
    updateActiveIndicator(0);
    
    
    // Start autoplay after a short delay
    setTimeout(() => {
      if (totalPages > 1) {
        startAutoplay();
      }
    }, 1000);
  }
  
  // Use a more reliable initialization approach
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCarousel);
  } else {
    // DOM is already ready
    setTimeout(initializeCarousel, 100);
  }

  // Handle visibility change to pause/resume autoplay
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });
  
  // Handle window resize to reinitialize if needed
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // If we switched from desktop to mobile or vice versa, reinitialize
      const shouldHaveCarousel = isMobile() && totalFeatures > 2;
      const hasCarousel = keyFeaturesWrapper.querySelector('.carousel-indicators') !== null;
      
      if (shouldHaveCarousel && !hasCarousel) {
        // Need to add carousel
        location.reload(); // Simple solution - reload the page
      } else if (!shouldHaveCarousel && hasCarousel) {
        // Need to remove carousel
        const indicators = keyFeaturesWrapper.querySelector('.carousel-indicators');
        if (indicators) indicators.remove();
        stopAutoplay();
      }
    }, 300);
  });
}

// Also make the initialization function globally accessible for debugging
window.initializeKeyFeaturesCarousel = initializeKeyFeaturesCarousel;

// Global function for debugging carousel
window.debugCarousel = function() {
  const container = document.querySelector('.key-features');
  const wrapper = document.querySelector('.key-features-wrapper');
  const features = container ? container.querySelectorAll('.feature-item') : [];
  const indicators = wrapper ? wrapper.querySelector('.carousel-indicators') : null;
  
  if (container) {
    const styles = window.getComputedStyle(container);
  }
  
  // Try to reinitialize
  initializeKeyFeaturesCarousel();
};

  // Get DOM elements
  const sizeOptions = document.querySelectorAll('.size-option');
  const colorCircles = document.querySelectorAll('.color-circle');
  const lockOptions = document.querySelectorAll('.lock-option');
  const addToCartBtn = document.getElementById('addToCartBtn');
  const mainAddToCartBtn = document.getElementById('main-add-to-cart') || addToCartBtn;
  const variantIdInput = document.getElementById('variantId');
  const productPrice = document.getElementById('productPrice');
  const deliverySelect = document.getElementById('deliverySelect');
  
  // Get main product image elements - Updated selectors for your gallery
  const mainGallery = document.querySelector('.product-gallery__main');
  const mainProductImage = document.querySelector('.product-gallery__main img, .product__images img, .featured-product__images img');
  const thumbnailImages = document.querySelectorAll('.thumbnail-slider__nav img, .product-gallery__thumbnails img');

  // Selected options
  let selectedSize = null;
  let selectedColor = null;
  let selectedLock = null;
  let selectedUpgrade = null; // Add upgrade tracking
  let selectedDelivery = 0; // No delivery cost (commented out in product builder)

  // Find matching variant
  function findMatchingVariant() {
    return productData.variants.find(variant => {
      const sizeMatch = !selectedSize || variant.option1 === selectedSize;
      
      // Handle color/upgrade in option2
      let option2Match = true;
      if (selectedColor) {
        option2Match = variant.option2 === selectedColor;
      } else if (selectedUpgrade && window.upgrade_option_location === 'option2') {
        option2Match = variant.option2 === selectedUpgrade;
      }
      
      // Handle lock/upgrade in option3
      let option3Match = true;
      if (selectedLock) {
        option3Match = variant.option3 === selectedLock;
      } else if (selectedUpgrade && window.upgrade_option_location === 'option3') {
        option3Match = variant.option3 === selectedUpgrade;
      }
      
      return sizeMatch && option2Match && option3Match;
    });
  }

  // Calculate total price including upgrades (no delivery cost)
  function calculateTotalPrice(variant) {
    console.log('Calculating total price for variant:', variant ? variant.id : 'no variant');
    
    // If we have a specific variant, use its exact price
    if (variant && variant.price) {
      console.log('Using exact variant price:', formatMoney(variant.price));
      return variant.price;
    }
    
    // Fallback: calculate from base price + upgrades
    const basePrice = variant ? variant.price : (productData ? productData.price : 0);
    const deliveryCost = 0; // No delivery cost (commented out in product builder)
    
    // Add upgrade costs if any - get from variant pricing difference
    let upgradeCost = 0;
    
    // If we have upgrade selection, find the price difference
    if (selectedUpgrade && selectedUpgrade !== 'None' && selectedUpgrade !== 'No Upgrade') {
      upgradeCost = extractUpgradeCost(selectedUpgrade);
    }
    
    // Add lock upgrade costs from variant pricing difference
    if (selectedLock && selectedLock !== 'None' && selectedLock !== 'No Lock' && selectedLock !== 'Standard') {
      const lockCost = extractPriceFromOption(selectedLock);
      upgradeCost += lockCost;
    }
    
    const totalPrice = basePrice + deliveryCost + upgradeCost;
    
    console.log('Price calculation details:', {
      basePrice: formatMoney(basePrice),
      deliveryCost: formatMoney(deliveryCost),
      upgradeCost: formatMoney(upgradeCost),
      totalPrice: formatMoney(totalPrice),
      usingVariantMethod: !!variant,
      selectedUpgrade,
      selectedLock
    });
    
    return totalPrice;
  }

  // Helper function to find variant matching current selections
  function findMatchingVariant() {
    if (!productData || !productData.variants) return null;
    
    console.log('Finding variant for selections:', {
      size: selectedSize,
      color: selectedColor,
      upgrade: selectedUpgrade,
      lock: selectedLock
    });
    
    return productData.variants.find(variant => {
      // More flexible size matching - check all options
      let sizeMatch = false;
      if (selectedSize) {
        sizeMatch = (
          variant.option1 === selectedSize ||
          variant.option2 === selectedSize ||
          variant.option3 === selectedSize
        );
      } else {
        sizeMatch = true; // If no size selected, don't filter by size
      }
      
      // Handle upgrade matching (can be in option1, option2 or option3)
      let upgradeMatch = true;
      if (selectedUpgrade && selectedUpgrade !== 'none' && selectedUpgrade !== 'No Upgrade') {
        upgradeMatch = (
          (variant.option1 && (
            variant.option1 === selectedUpgrade ||
            (selectedUpgrade.length > 5 && variant.option1.includes(selectedUpgrade.substring(0, Math.min(20, selectedUpgrade.length))))
          )) ||
          (variant.option2 && (
            selectedUpgrade.includes('LED LIGHT PACKAGE') && variant.option2.includes('LED LIGHT PACKAGE') ||
            variant.option2 === selectedUpgrade
          )) ||
          (variant.option3 && (
            selectedUpgrade.includes('LED LIGHT PACKAGE') && variant.option3.includes('LED LIGHT PACKAGE') ||
            variant.option3 === selectedUpgrade
          ))
        );
      } else {
        // No upgrade selected, so find variant without upgrades
        const upgradeKeywords = ['LED LIGHT PACKAGE', 'LED LIGHT', 'LIGHT PACKAGE', 'UPGRADE KIT'];
        const hasUpgradeInOption1 = variant.option1 && upgradeKeywords.some(kw => variant.option1.toUpperCase().includes(kw));
        upgradeMatch = (
          (!hasUpgradeInOption1 || (variant.option1 && variant.option1.includes('No Upgrade'))) &&
          (!variant.option2 || variant.option2.includes('No Upgrade') || !variant.option2.includes('LED LIGHT PACKAGE')) &&
          (!variant.option3 || variant.option3.includes('No Upgrade') || !variant.option3.includes('LED LIGHT PACKAGE'))
        );
      }
      
      // Handle lock matching (can be in option2 or option3) - but only check if we have actual lock options
      let lockMatch = true;
      if (selectedLock && selectedLock !== 'none') {
        // Check if this is actually a lock value (contains lock-related terms)
        const isLockValue = selectedLock.toLowerCase().includes('electronic') || 
                           selectedLock.toLowerCase().includes('mechanical') || 
                           selectedLock.toLowerCase().includes('dial') ||
                           selectedLock.toLowerCase().includes('lock');
        
        if (isLockValue) {
          lockMatch = (
            (variant.option2 && (
              (selectedLock.includes('Electronic') && variant.option2.includes('Electronic')) ||
              (selectedLock.includes('Mechanical') && variant.option2.includes('Mechanical')) ||
              variant.option2 === selectedLock
            )) ||
            (variant.option3 && (
              (selectedLock.includes('Electronic') && variant.option3.includes('Electronic')) ||
              (selectedLock.includes('Mechanical') && variant.option3.includes('Mechanical')) ||
              variant.option3 === selectedLock
            ))
          );
        }
      }
      
      // Handle color matching (only check if we have actual color options)
      let colorMatch = true;
      if (selectedColor && selectedColor !== 'none') {
        // Check if this is actually a color value (doesn't contain lock or upgrade terms)
        const isColorValue = !selectedColor.toLowerCase().includes('electronic') && 
                            !selectedColor.toLowerCase().includes('mechanical') && 
                            !selectedColor.toLowerCase().includes('led light') &&
                            !selectedColor.toLowerCase().includes('upgrade');
        
        if (isColorValue) {
          colorMatch = (
            variant.option2 === selectedColor ||
            variant.option3 === selectedColor
          );
        }
      }
      
      const isMatch = sizeMatch && upgradeMatch && lockMatch && colorMatch;
      
      if (isMatch) {
        console.log('Found matching variant:', {
          id: variant.id,
          price: variant.price,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
          matches: { sizeMatch, upgradeMatch, lockMatch, colorMatch }
        });
      }
      
      return isMatch;
    }) || productData.variants[0]; // Fallback to first variant if no match found
  }

  // Helper function to extract upgrade cost from variant pricing
  function extractUpgradeCost(upgradeText) {
    if (!upgradeText) return 0;
    
    console.log('Extracting upgrade cost for:', upgradeText);
    
    // First try to get price from variant difference
    const currentVariant = findMatchingVariant();
    if (currentVariant && productData && productData.variants) {
      console.log('Current variant found:', currentVariant.id, 'Price:', currentVariant.price);
      
      // Find a base variant with the same size but no upgrades
      const baseVariant = productData.variants.find(variant => {
        const sizeMatch = variant.option1 === selectedSize;
        const colorMatch = (!selectedColor) || (variant.option2 === selectedColor || variant.option3 === selectedColor);
        
        // Look for base variant (no upgrade options)
        const isBaseUpgrade = (
          (variant.option2 && (variant.option2.includes('No Upgrade') || variant.option2 === 'None')) ||
          (variant.option3 && (variant.option3.includes('No Upgrade') || variant.option3 === 'None')) ||
          (!variant.option2.includes('LED') && !variant.option2.includes('LIGHT') && !variant.option2.includes('PACKAGE')) ||
          (!variant.option3.includes('LED') && !variant.option3.includes('LIGHT') && !variant.option3.includes('PACKAGE'))
        );
        
        return sizeMatch && colorMatch && isBaseUpgrade;
      });
      
      if (baseVariant && currentVariant.price > baseVariant.price) {
        const priceDifference = currentVariant.price - baseVariant.price;
        console.log('Found variant price difference:', priceDifference, 'cents between variants', baseVariant.id, 'and', currentVariant.id);
        return priceDifference;
      } else {
        console.log('Base variant:', baseVariant ? baseVariant.id : 'not found');
      }
      
      // Alternative approach: look for variants with the exact upgrade text
      const upgradeVariants = productData.variants.filter(variant => {
        const hasUpgradeInOption2 = variant.option2 && variant.option2.includes('LED LIGHT PACKAGE');
        const hasUpgradeInOption3 = variant.option3 && variant.option3.includes('LED LIGHT PACKAGE');
        const sizeMatch = variant.option1 === selectedSize;
        
        return sizeMatch && (hasUpgradeInOption2 || hasUpgradeInOption3);
      });
      
      if (upgradeVariants.length > 0) {
        console.log('Found upgrade variants:', upgradeVariants.map(v => ({ id: v.id, price: v.price, option2: v.option2, option3: v.option3 })));
        
        // Find the cheapest base variant for this size to calculate difference
        const baseVariants = productData.variants.filter(variant => {
          const sizeMatch = variant.option1 === selectedSize;
          const noUpgrade = (!variant.option2 || !variant.option2.includes('LED')) && 
                           (!variant.option3 || !variant.option3.includes('LED'));
          return sizeMatch && noUpgrade;
        });
        
        if (baseVariants.length > 0) {
          const cheapestBase = baseVariants.reduce((prev, curr) => prev.price < curr.price ? prev : curr);
          const cheapestUpgrade = upgradeVariants.reduce((prev, curr) => prev.price < curr.price ? prev : curr);
          const priceDifference = cheapestUpgrade.price - cheapestBase.price;
          
          console.log('Calculated upgrade cost:', priceDifference, 'cents (from variants', cheapestBase.id, 'to', cheapestUpgrade.id, ')');
          return priceDifference;
        }
      }
    }
    
    // Fallback to text parsing if variant pricing doesn't work
    console.log('Falling back to text parsing for upgrade cost');
    return extractPriceFromText(upgradeText);
  }

  // Helper function to extract price from option text (for locks, etc.)
  function extractPriceFromOption(optionText) {
    if (!optionText) return 0;
    
    console.log('Extracting lock cost for:', optionText);
    
    // First try to get price from variant difference
    const currentVariant = findMatchingVariant();
    if (currentVariant && productData && productData.variants) {
      console.log('Current variant for lock:', currentVariant.id, 'Price:', currentVariant.price);
      
      // Find a base variant with the same size/upgrade but different lock
      const baseVariant = productData.variants.find(variant => {
        const sizeMatch = variant.option1 === selectedSize;
        const upgradeMatch = (!selectedUpgrade || selectedUpgrade === 'none') || 
                            (variant.option2 === selectedUpgrade || variant.option3 === selectedUpgrade) ||
                            (variant.option2 && variant.option2.includes('LED LIGHT PACKAGE') && selectedUpgrade && selectedUpgrade.includes('LED LIGHT PACKAGE'));
        
        // Find base lock (usually Electronic, Standard, Basic, or Mechanical without additional cost)
        const isBaseLock = (
          (variant.option2 && (variant.option2.includes('Electronic') || variant.option2 === 'Standard' || variant.option2 === 'Basic')) ||
          (variant.option3 && (variant.option3.includes('Electronic') || variant.option3 === 'Standard' || variant.option3 === 'Basic')) ||
          (!variant.option2.includes('Mechanical Dial') && !variant.option3.includes('Mechanical Dial'))
        );
        
        return sizeMatch && upgradeMatch && isBaseLock;
      });
      
      if (baseVariant && currentVariant.price > baseVariant.price) {
        const priceDifference = currentVariant.price - baseVariant.price;
        console.log('Found lock price difference:', priceDifference, 'cents between variants', baseVariant.id, 'and', currentVariant.id);
        return priceDifference;
      } else {
        console.log('Base lock variant:', baseVariant ? baseVariant.id : 'not found');
      }
      
      // Alternative approach: find variants with Electronic vs Mechanical Dial for same size/upgrade
      const electronicVariants = productData.variants.filter(variant => {
        const sizeMatch = variant.option1 === selectedSize;
        const hasElectronic = (variant.option2 && variant.option2.includes('Electronic')) || 
                             (variant.option3 && variant.option3.includes('Electronic'));
        const upgradeMatch = (!selectedUpgrade) || 
                            (variant.option2 && selectedUpgrade && variant.option2.includes('LED LIGHT PACKAGE') && selectedUpgrade.includes('LED LIGHT PACKAGE')) ||
                            (variant.option3 && selectedUpgrade && variant.option3.includes('LED LIGHT PACKAGE') && selectedUpgrade.includes('LED LIGHT PACKAGE'));
        
        return sizeMatch && hasElectronic && upgradeMatch;
      });
      
      const mechanicalVariants = productData.variants.filter(variant => {
        const sizeMatch = variant.option1 === selectedSize;
        const hasMechanical = (variant.option2 && variant.option2.includes('Mechanical Dial')) || 
                             (variant.option3 && variant.option3.includes('Mechanical Dial'));
        const upgradeMatch = (!selectedUpgrade) || 
                            (variant.option2 && selectedUpgrade && variant.option2.includes('LED LIGHT PACKAGE') && selectedUpgrade.includes('LED LIGHT PACKAGE')) ||
                            (variant.option3 && selectedUpgrade && variant.option3.includes('LED LIGHT PACKAGE') && selectedUpgrade.includes('LED LIGHT PACKAGE'));
        
        return sizeMatch && hasMechanical && upgradeMatch;
      });
      
      if (electronicVariants.length > 0 && mechanicalVariants.length > 0 && optionText.includes('Mechanical')) {
        const electronicPrice = electronicVariants[0].price;
        const mechanicalPrice = mechanicalVariants[0].price;
        const priceDifference = mechanicalPrice - electronicPrice;
        
        console.log('Calculated lock upgrade cost:', priceDifference, 'cents (Electronic:', electronicPrice, 'vs Mechanical:', mechanicalPrice, ')');
        return priceDifference;
      }
    }
    
    // Fallback to text parsing
    console.log('Falling back to text parsing for lock cost');
    return extractPriceFromText(optionText);
  }

  // Helper function to extract price from text (fallback method)
  function extractPriceFromText(text) {
    if (!text) return 0;
    
    // Try to extract price from text
    // Look for patterns like "+$123", "$123", "(+$123)", "Price: $123", etc.
    const textStr = text.toString();
    
    // Multiple price patterns to try
    const patterns = [
      /\+\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)/i,        // +$123 or + $123
      /\(\+\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)\)/i,    // (+$123) or (+ $123)
      /price:\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)/i,    // Price: $123
      /cost:\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)/i,     // Cost: $123
      /\$(\d+(?:,\d{3})*(?:\.\d{2})?)\s*(?:extra|additional|more)/i, // $123 extra
      /add\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)/i,       // add $123
      /\$(\d+(?:,\d{3})*(?:\.\d{2})?)/                // Last resort: any $123
    ];
    
    for (const pattern of patterns) {
      const priceMatch = textStr.match(pattern);
      if (priceMatch) {
        // Remove commas and convert to cents
        const priceStr = priceMatch[1].replace(/,/g, '');
        const cost = Math.round(parseFloat(priceStr) * 100);
        console.log('Text price found:', cost, 'cents from pattern:', pattern, 'in text:', textStr);
        return cost;
      }
    }
    
    console.log('No price found in text:', textStr);
    return 0;
  }

  // Format money with commas
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    const parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  // Update price display
  function updatePriceDisplay() {
    const variant = findMatchingVariant();
    if (variant) {
      const basePrice = variant.price;
      const totalPrice = calculateTotalPrice(variant);
      
      let priceHTML = '';
      
      if (selectedDelivery > 0) {
        // Check for compare at price
        if (variant.compare_at_price && variant.compare_at_price > basePrice) {
          const savings = variant.compare_at_price - basePrice;
          const percentOff = Math.round((savings / variant.compare_at_price) * 100);
          priceHTML = `
            <div class="price-breakdown">
              <div class="total-price">
                <div class="price-compare-container">
                  <span class="compare-price">${formatMoney(variant.compare_at_price)}</span>
                  <span class="percent-badge">${percentOff}% Off</span>
                </div>
                <span class="sale-price">${formatMoney(totalPrice)}</span>
              </div>
            </div>
          `;
        } else {
          priceHTML = `
            <div class="price-breakdown">
              <div class="total-price">${formatMoney(totalPrice)}</div>
            </div>
          `;
        }
      } else {
        // Check for compare at price
        if (variant.compare_at_price && variant.compare_at_price > basePrice) {
          const savings = variant.compare_at_price - basePrice;
          const percentOff = Math.round((savings / variant.compare_at_price) * 100);
          priceHTML = `
            <div class="price-breakdown">
              <div class="total-price">
                <div class="price-compare-container">
                  <span class="compare-price">${formatMoney(variant.compare_at_price)}</span>
                  <span class="percent-badge">${percentOff}% Off</span>
                </div>
                <span class="sale-price">${formatMoney(basePrice)}</span>
              </div>
            </div>
          `;
        } else {
          priceHTML = `
            <div class="price-breakdown">
              <div class="total-price">${formatMoney(basePrice)}</div>
            </div>
          `;
        }
      }
      
      productPrice.innerHTML = priceHTML;
      
      // Update order summary
      updateOrderSummary(variant, totalPrice);
      
      // Update sticky cart
      updateStickyCart(totalPrice);
    }
  }

  // Update order summary
  function updateOrderSummary(variant, totalPrice) {
    console.log('Updating order summary:', {
      variant: variant ? variant.id : null,
      totalPrice,
      selectedSize,
      selectedColor,
      selectedLock,
      selectedUpgrade
    });
    
    const selectedSizeSummary = document.getElementById('selected-size-summary');
    const selectedColorSummary = document.getElementById('selected-color-summary');
    const selectedLockSummary = document.getElementById('selected-lock-summary');
    const selectedUpgradesSummary = document.getElementById('selected-upgrades-summary');
    const totalPriceSummary = document.getElementById('total-price-summary');
    
    // Get the summary row elements
    const colorSummaryRow = document.getElementById('color-summary-row');
    const lockSummaryRow = document.getElementById('lock-summary-row');
    const upgradesSummaryRow = document.getElementById('upgrades-summary-row');
    
    if (selectedSizeSummary) {
      selectedSizeSummary.textContent = selectedSize || 'Not selected';
    }
    
    // Handle color summary - only show if color options exist
    if (selectedColorSummary && colorSummaryRow) {
      selectedColorSummary.textContent = selectedColor || 'Not selected';
      // colorSummaryRow will already be hidden/shown by Liquid logic
    }
    
    // Handle lock summary - only show if lock options exist
    if (selectedLockSummary && lockSummaryRow) {
      selectedLockSummary.textContent = selectedLock || 'Not selected';
      // lockSummaryRow will already be hidden/shown by Liquid logic
    }
    
    // Handle upgrades summary - only show if upgrade options exist
    if (selectedUpgradesSummary && upgradesSummaryRow) {
      if (selectedUpgrade && selectedUpgrade !== 'None') {
        // Format upgrade display text for order summary
        let upgradeDisplayText = selectedUpgrade;
        
        // Check if it's an LED package with colon and pipe separators
        if (selectedUpgrade.includes(':') && selectedUpgrade.includes('|')) {
          const packageName = selectedUpgrade.split(':')[0].trim();
          const afterColon = selectedUpgrade.split(':')[1].trim();
          const parts = afterColon.split('|').map(part => part.trim());
          upgradeDisplayText = `${packageName} includes: ${parts.join(', ')}`;
        } else if (selectedUpgrade.includes('|')) {
          // No colon, just pipe-separated items
          const parts = selectedUpgrade.split('|').map(part => part.trim());
          upgradeDisplayText = `Includes: ${parts.join(', ')}`;
        }
        
        selectedUpgradesSummary.textContent = upgradeDisplayText;
      } else {
        selectedUpgradesSummary.textContent = 'None';
      }
      // upgradesSummaryRow will already be hidden/shown by Liquid logic
    }
    
    if (totalPriceSummary) {
      totalPriceSummary.textContent = formatMoney(totalPrice);
    }
  }

  // Update sticky cart
  function updateStickyCart(totalPrice) {
    const stickyCartPrice = document.getElementById('sticky-cart-price');
    const cartPrice = document.getElementById('cartPrice');
    
    console.log('Updating sticky cart with price:', formatMoney(totalPrice));
    
    if (stickyCartPrice) {
      stickyCartPrice.textContent = formatMoney(totalPrice);
    }
    
    if (cartPrice) {
      cartPrice.textContent = formatMoney(totalPrice);
    }
    
    // Update button disabled state based on variant availability
    const variant = findMatchingVariant();
    const stickyButton = document.getElementById('sticky-add-to-cart');
    const isDisabled = !variant || !variant.available;
    
    if (stickyButton) {
      stickyButton.disabled = isDisabled;
      // Also update the sticky button text with price
      if (!isDisabled) {
        stickyButton.innerHTML = `Add to Cart - <span id="sticky-cart-price">${formatMoney(totalPrice)}</span>`;
      } else {
        stickyButton.innerHTML = 'Select All Options';
      }
    }
    
    if (mainAddToCartBtn) {
      mainAddToCartBtn.disabled = isDisabled;
    }
    
    if (addToCartBtn) {
      addToCartBtn.disabled = isDisabled;
      // Update main add to cart button text
      if (!isDisabled) {
        const cartPriceSpan = addToCartBtn.querySelector('#cartPrice');
        if (cartPriceSpan) {
          cartPriceSpan.textContent = formatMoney(totalPrice);
        } else {
          addToCartBtn.innerHTML = `Add to Cart - <span id="cartPrice">${formatMoney(totalPrice)}</span>`;
        }
      } else {
        addToCartBtn.textContent = 'Select All Options';
      }
    }
  }

  // Update cart properties with all selections
  function updateCartProperties() {
    console.log('Updating cart properties with selections:', {
      size: selectedSize,
      color: selectedColor,
      lock: selectedLock,
      upgrade: selectedUpgrade
    });

    // Update size property
    const selectedSizeProperty = document.getElementById('selectedSizeProperty');
    if (selectedSizeProperty) {
      selectedSizeProperty.value = selectedSize || '';
    }
    
    // Update color property
    const selectedColorProperty = document.getElementById('selectedColorProperty');
    if (selectedColorProperty) {
      selectedColorProperty.value = selectedColor || '';
    }
    
    // Update lock property
    const selectedLockProperty = document.getElementById('selectedLockProperty');
    if (selectedLockProperty) {
      selectedLockProperty.value = selectedLock || '';
    }
    
    // Update upgrade property
    const selectedUpgradeProperty = document.getElementById('selectedUpgradeProperty');
    if (selectedUpgradeProperty) {
      selectedUpgradeProperty.value = selectedUpgrade || '';
    }
  }

  // Update variant and price - using Shopify's standard logic
  function updateSelectedVariant() {
    const variant = findMatchingVariant();
    
    console.log('Updating selected variant:', variant ? variant.id : 'none found');
    
    if (variant) {
      // Update variant ID
      variantIdInput.value = variant.id;
      
      // Update cart properties with all selections
      updateCartProperties();
      
      // Calculate total price including upgrades
      const totalPrice = calculateTotalPrice(variant);
      
      // Update price displays
      updatePriceDisplay();
      
      // Update sticky cart with the calculated total price
      updateStickyCart(totalPrice);
      
      // Update variant-specific information
      updateVariantInfo(variant);

      // Try image update but don't let it break everything else - skip it entirely if problematic
      try {
        // Only attempt image update if JSON looks valid
        const productId = productData.id;
        const variantImagesScript = document.getElementById(`variant-images-${productId}`);
        
        if (variantImagesScript && variantImagesScript.textContent.includes('metafield_raw')) {
          console.log('Skipping image update due to known JSON issues...');
        } else {
          updateMainGalleryImageShopifyWay(variant);
        }
      } catch (imageError) {
        console.warn('Image update failed, but continuing with variant selection:', imageError);
      }
      
      // Update button states
      addToCartBtn.disabled = !variant.available;
      if (variant.available) {
        const cartPriceSpan = addToCartBtn.querySelector('#cartPrice');
        if (cartPriceSpan) {
          cartPriceSpan.textContent = formatMoney(totalPrice);
        }
      } else {
        addToCartBtn.textContent = 'Sold Out';
      }
      
      // Update URL without page reload (optional)
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);
      }
    } else {
      console.warn('No matching variant found for selections:', {
        size: selectedSize,
        color: selectedColor,
        lock: selectedLock,
        upgrade: selectedUpgrade
      });
      
      // Disable buttons and show message
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Select All Options';
      
      const stickyButton = document.getElementById('sticky-add-to-cart');
      if (stickyButton) {
        stickyButton.disabled = true;
        stickyButton.textContent = 'Select All Options';
      }
    }
  }

  // Shopify's exact logic for updating main gallery image
  function updateMainGalleryImageShopifyWay(variant) {
    
    if (!variant) {
      return;
    }

    const productId = productData.id;
    const variantImagesScript = document.getElementById(`variant-images-${productId}`);
    

    
    if (!variantImagesScript) {
      return;
    }

    try {
      const variantData = JSON.parse(variantImagesScript.textContent);
      const variantImageData = variantData.variants[variant.id];
      

      // First, try to switch gallery using featured_media position (Shopify's preferred method)
      if (variant.featured_media && variant.featured_media.position) {
        const imagePosition = variant.featured_media.position - 1; // Convert to 0-based index
        
        // Try with jQuery if available
        if (typeof $ !== 'undefined') {
          const $productGallery = $('.product-gallery__main');
          if ($productGallery.length && typeof $productGallery.flickity === 'function') {
            $productGallery.flickity('select', imagePosition);
            return; // Exit early if we successfully used position-based switching
          }
        }
        
        // Fallback: Try with vanilla JS Flickity
        const productGallery = document.querySelector('.product-gallery__main');
        if (productGallery && typeof Flickity !== 'undefined') {
          const flkty = Flickity.data(productGallery);
          if (flkty && flkty.cells && flkty.cells.length > imagePosition) {
            flkty.select(imagePosition);
            return;
          }
        }
      }
      
      // Fallback: Use image URL switching if position method didn't work
      if (!variantImageData) {
        return;
      }

      let $productGallery, $currentSelectedImage;
      
      // Try jQuery approach first
      if (typeof $ !== 'undefined') {
        $productGallery = $('.product-gallery__main');
        $currentSelectedImage = $productGallery.find('.product-gallery__image.is-selected img');
      } else {
        // Vanilla JS fallback
        const galleryElement = document.querySelector('.product-gallery__main');
        const selectedImageElement = galleryElement ? galleryElement.querySelector('.product-gallery__image.is-selected img') : null;
        
        $productGallery = {
          length: galleryElement ? 1 : 0,
          flickity: function(command) {
            if (galleryElement && typeof Flickity !== 'undefined') {
              const flkty = Flickity.data(galleryElement);
              if (flkty && command === 'resize') {
                flkty.resize();
              }
            }
          }
        };
        
        $currentSelectedImage = {
          length: selectedImageElement ? 1 : 0,
          attr: function(name, value) {
            if (selectedImageElement) {
              if (value !== undefined) {
                selectedImageElement.setAttribute(name, value);
              } else {
                return selectedImageElement.getAttribute(name);
              }
            }
          },
          closest: function(selector) {
            return {
              length: selectedImageElement && selectedImageElement.closest(selector) ? 1 : 0,
              attr: function(name, value) {
                const element = selectedImageElement ? selectedImageElement.closest(selector) : null;
                if (element) {
                  if (value !== undefined) {
                    element.setAttribute(name, value);
                  } else {
                    return element.getAttribute(name);
                  }
                }
              }
            };
          }
        };
      }
      
      console.log('Gallery elements found:', {
        $productGallery: $productGallery.length,
        $currentSelectedImage: $currentSelectedImage.length
      });
      
      if (!$productGallery.length || !$currentSelectedImage.length) {
        return;
      }

      let newImageUrl = null;
      let newImageAlt = '';

      // Check if LED upgrade is selected and bundle kit image is available
      const isLEDUpgradeSelected = selectedUpgrade && 
        (selectedUpgrade.toLowerCase().includes('led') || selectedUpgrade.toLowerCase().includes('light'));
      
      // Debug logging for bundle kit image
      console.log('Bundle kit image debug:', {
        selectedUpgrade: selectedUpgrade,
        isLEDUpgradeSelected: isLEDUpgradeSelected,
        variantImageData: variantImageData,
        bundle_kit_image_url: variantImageData ? variantImageData.bundle_kit_image_url : 'no variantImageData',
        variant_id: variant ? variant.id : 'no variant'
      });
      
      if (isLEDUpgradeSelected && variantImageData.bundle_kit_image_url) {
        // Use bundle kit image for LED upgrades
        newImageUrl = variantImageData.bundle_kit_image_url;
        newImageAlt = `${variant.title} with LED Light Package`;
        console.log('Using bundle kit image for LED upgrade:', newImageUrl);
      } else if (variantImageData.featured_image_url) {
        // Use variant image if available, otherwise fall back to product featured image
        newImageUrl = variantImageData.featured_image_url;
        newImageAlt = variantImageData.featured_image_alt || variant.title;
      } else if (variantData.product_featured_image_url) {
        newImageUrl = variantData.product_featured_image_url;
        newImageAlt = productData.title;
      }

      if (newImageUrl && $currentSelectedImage.attr('src') !== newImageUrl) {
        
        // Update the main image
        $currentSelectedImage.attr('src', newImageUrl);
        $currentSelectedImage.attr('alt', newImageAlt);
        
        // Update data attributes for zoom and other functionality
        $currentSelectedImage.attr('data-zoom-src', newImageUrl.replace('width=1024', 'width=2048'));
        
        // Update parent link if lightbox is enabled
        const $parentLink = $currentSelectedImage.closest('.product-gallery__link');
        if ($parentLink.length) {
          $parentLink.attr('href', newImageUrl.replace('width=1024', 'width=2048'));
          $parentLink.attr('title', newImageAlt);
        }

        // Trigger resize to ensure Flickity adjusts properly
        setTimeout(() => {
          if (typeof $productGallery.flickity === 'function') {
            $productGallery.flickity('resize');
          }
        }, 100);

        // Update thumbnails to show active state for the new image
        updateThumbnailActiveStateShopifyWay(variant);
        
      } else {
        console.log('No image update needed or no new image URL');
      }
    } catch (error) {
      console.error('Error updating main gallery image:', error);
    }
  }

  // Shopify's exact logic for updating thumbnail active state
  function updateThumbnailActiveStateShopifyWay(variant) {
    if (!variant || !variant.featured_image) return;

    let $thumbnails;
    
    if (typeof $ !== 'undefined') {
      $thumbnails = $('.product-gallery__thumbnails .product-gallery__thumbnail');
    } else {
      // Vanilla JS fallback
      const thumbnailElements = document.querySelectorAll('.product-gallery__thumbnails .product-gallery__thumbnail');
      $thumbnails = {
        each: function(callback) {
          thumbnailElements.forEach((element, index) => {
            const $thumbnail = {
              find: function(selector) {
                const found = element.querySelector(selector);
                return {
                  attr: function(attr) {
                    return found ? found.getAttribute(attr) : null;
                  }
                };
              },
              addClass: function(className) {
                element.classList.add(className);
              },
              removeClass: function(className) {
                element.classList.remove(className);
              }
            };
            callback.call(element, index, $thumbnail);
          });
        }
      };
    }
    
    $thumbnails.each(function(index, $thumbnail) {
      const thumbnailImg = typeof $ !== 'undefined' ? $thumbnail.find('img') : $thumbnail.find('img');
      const thumbnailSrc = thumbnailImg.attr('src');
      
      // Check if this thumbnail corresponds to the variant's featured image
      if (thumbnailSrc && thumbnailSrc.includes(variant.featured_image.id)) {
        if (typeof $ !== 'undefined') {
          $thumbnail.addClass('is-active');
        } else {
          $thumbnail.addClass('is-active');
        }
      } else {
        if (typeof $ !== 'undefined') {
          $thumbnail.removeClass('is-active');
        } else {
          $thumbnail.removeClass('is-active');
        }
      }
    });
  }

  // Update delivery price display
  if (deliverySelect) {
    deliverySelect.addEventListener('change', function() {
      selectedDelivery = parseInt(this.value);
      updatePriceDisplay();
    });
  }

  // Update variant-specific information
  function updateVariantInfo(variant) {
    
    // Get the active size option to access metafield data
    const activeSizeOption = document.querySelector('.size-option.active');
    
    console.log('Updating variant info:', {
      variant: variant ? variant.id : 'none',
      activeSizeOption: activeSizeOption ? {
        size: activeSizeOption.dataset.size,
        externalDimensions: activeSizeOption.dataset.externalDimensions,
        internalDimensions: activeSizeOption.dataset.internalDimensions,
        weight: activeSizeOption.dataset.weight,
        gunCapacity: activeSizeOption.dataset.gunCapacity
      } : 'none'
    });
    
    // Update gun capacity
    const gunCapacityElement = document.querySelector('#variantGunCapacity .info-text');
    const gunCapacityContainer = document.querySelector('#variantGunCapacity');
    if (gunCapacityElement && gunCapacityContainer) {
      const gunCapacity = activeSizeOption?.dataset.gunCapacity;
      // console.log('Gun capacity from data attribute:', gunCapacity); // Debug log

      // Check if variant-level gun capacity exists and has a valid value
      const hasVariantGunCapacity = gunCapacity && 
                                   gunCapacity !== 'null' && 
                                   gunCapacity !== '' && 
                                   gunCapacity !== 'undefined' &&
                                   gunCapacity.trim() !== '';
      
      if (hasVariantGunCapacity) {
        gunCapacityElement.textContent = `Up to ${gunCapacity} long guns`;
        gunCapacityContainer.style.display = 'flex'; // Show the container
      } else {
        // Fallback to product-level gun_count
        const productGunCount = productData.metafields?.custom?.gun_count;

        // Check if product-level gun count exists and has a valid value
        const hasProductGunCount = productGunCount && 
                                  productGunCount !== 'null' && 
                                  productGunCount !== '' && 
                                  productGunCount !== 'undefined' &&
                                  productGunCount.toString().trim() !== '';
        
        if (hasProductGunCount) {
          gunCapacityElement.textContent = `Up to ${productGunCount} long guns`;
          gunCapacityContainer.style.display = 'flex'; // Show the container
        } else {
          // Hide the entire gun capacity section when no valid data is available
          gunCapacityContainer.style.display = 'none';
        }
      }
    }

    // Update weight
    const weightElement = document.querySelector('#variantWeight .info-text');
    if (weightElement) {
      const weight = activeSizeOption?.dataset.weight;
      if (weight && weight !== 'null' && weight !== '') {
        weightElement.textContent = `${weight} lbs`;
      } else if (variant.weight) {
        // Convert grams to pounds if needed
        const weightInPounds = variant.weight > 1000 ? Math.round(variant.weight * 0.00220462) : variant.weight;
        weightElement.textContent = `${weightInPounds} lbs`;
      } else {
        weightElement.textContent = 'Weight: TBA';
      }
    }

    // Update delivery options
    updateDeliveryOptions(activeSizeOption);

    // Update external dimensions
    const externalDimensionsElement = document.querySelector('#variantExternalDimensions .info-text');
    const externalDimensionsContainer = document.querySelector('#variantExternalDimensions');
    let hasExternalDimensions = false;
    if (activeSizeOption && externalDimensionsElement && externalDimensionsContainer) {
      const externalDimensions = activeSizeOption.dataset.externalDimensions;
      if (externalDimensions && externalDimensions !== 'null' && externalDimensions !== '') {
        externalDimensionsElement.textContent = `External: ${externalDimensions}`;
        externalDimensionsContainer.style.display = 'flex';
        hasExternalDimensions = true;
      } else {
        externalDimensionsContainer.style.display = 'none';
      }
    }

    // Update internal dimensions
    const internalDimensionsElement = document.querySelector('#variantInternalDimensions .info-text');
    const internalDimensionsContainer = document.querySelector('#variantInternalDimensions');
    let hasInternalDimensions = false;
    if (activeSizeOption && internalDimensionsElement && internalDimensionsContainer) {
      const internalDimensions = activeSizeOption.dataset.internalDimensions;
      if (internalDimensions && internalDimensions !== 'null' && internalDimensions !== '') {
        internalDimensionsElement.textContent = `Internal: ${internalDimensions}`;
        internalDimensionsContainer.style.display = 'flex';
        hasInternalDimensions = true;
      } else {
        internalDimensionsContainer.style.display = 'none';
      }
    }

    // Update dimensions - Complete logic (fallback dimensions only if specific dimensions not available)
    const dimensionsElement = document.querySelector('#variantDimensions .info-text');
    const dimensionsContainer = document.querySelector('#variantDimensions');
    
    // Only show fallback dimensions if we don't have specific external/internal dimensions
    if (dimensionsElement && dimensionsContainer && variant.option1 && (!hasExternalDimensions && !hasInternalDimensions)) {
      const sizeName = variant.option1;
      let dimensions = 'Dimensions: TBA';
      
      // Show the fallback container
      dimensionsContainer.style.display = 'flex';
      
      // Pattern 1: Look for dimensions after " - "
      if (sizeName.includes(' - ')) {
        const parts = sizeName.split(' - ');
        if (parts.length > 1) {
          const lastPart = parts[parts.length - 1];
          // Check if the last part contains dimension-like content
          if (lastPart.includes('"') || lastPart.includes('x') || lastPart.includes('X')) {
            dimensions = lastPart;
          }
        }
      }
      
      // Pattern 2: Look for dimension pattern directly in the string
      if (dimensions === 'Dimensions: TBA') {
        // Look for patterns like "60.5"x 30"x 24"" or "60.5" x 30" x 24""
        const dimensionPattern = /(\d+\.?\d*"?\s*[xX]\s*\d+\.?\d*"?\s*[xX]\s*\d+\.?\d*"?)/;
        const match = sizeName.match(dimensionPattern);
        if (match) {
          dimensions = match[1];
        } else {
          // Look for simpler patterns like "60x30x24"
          const simplePattern = /(\d+\.?\d*\s*[xX]\s*\d+\.?\d*\s*[xX]\s*\d+\.?\d*)/;
          const simpleMatch = sizeName.match(simplePattern);
          if (simpleMatch) {
            dimensions = simpleMatch[1];
          }
        }
      }
      
      // Pattern 3: If still not found, try to extract anything with quotes and x
      if (dimensions === 'Dimensions: TBA' && sizeName.includes('"')) {
        // Look for any sequence with quotes and x
        const quotePattern = /(\d+\.?\d*"[^"]*[xX][^"]*\d+\.?\d*"[^"]*[xX][^"]*\d+\.?\d*")/;
        const quoteMatch = sizeName.match(quotePattern);
        if (quoteMatch) {
          dimensions = quoteMatch[1];
        }
      }
      
      // Pattern 4: Last resort - if it has dimensions somewhere, try to find them
      if (dimensions === 'Dimensions: TBA') {
        // Split by common separators and look for dimension-like strings
        const words = sizeName.split(/[\s\-,]+/);
        for (let word of words) {
          if (word.includes('x') || word.includes('X')) {
            const parts = word.split(/[xX]/);
            if (parts.length >= 3 && parts.every(part => /\d/.test(part))) {
              dimensions = word;
              break;
            }
          }
        }
      }
      
      // Pattern 5: Try extracting dimensions from the end of the string
      if (dimensions === 'Dimensions: TBA') {
        // Look for dimensions at the end like "Model Name - 60.5" x 30" x 24""
        const endPattern = /(\d+\.?\d*"\s*x\s*\d+\.?\d*"\s*x\s*\d+\.?\d*")$/i;
        const endMatch = sizeName.match(endPattern);
        if (endMatch) {
          dimensions = endMatch[1];
        }
      }
      
      // Clean up the dimensions string
      if (dimensions !== 'Dimensions: TBA') {
        // Clean up extra spaces and standardize format
        dimensions = dimensions.replace(/\s+/g, ' ').trim();
        // Ensure it doesn't start with unwanted characters
        dimensions = dimensions.replace(/^[^\d]*([\d"].*)/, '$1');
        // Standardize x separators
        dimensions = dimensions.replace(/\s*[xX]\s*/g, ' x ');
      }
      
      dimensionsElement.textContent = dimensions;
    } else if (dimensionsContainer) {
      // Hide fallback dimensions if we have specific external/internal dimensions or no variant
      dimensionsContainer.style.display = 'none';
    }
  }

  // New function to update delivery options with all 5 metafields
  function updateDeliveryOptions(activeSizeOption) {
  const deliverySelect = document.getElementById('deliverySelect');
  const deliveryItem = document.querySelector('.delivery-item');
  if (!deliverySelect || !activeSizeOption || !deliveryItem) return;

  // Get all delivery options from variant metafields
  const deliveryStartingAt = activeSizeOption.dataset.deliveryStartingAt;
  const deliveryPickup = activeSizeOption.dataset.deliveryPickup;
  const deliveryStairs = activeSizeOption.dataset.deliveryStairs;
  const deliveryInhome = activeSizeOption.dataset.deliveryInhome;
  const deliveryCurbside = activeSizeOption.dataset.deliveryCurbside;
  
  console.log('All delivery options:', { 
    deliveryStartingAt, 
    deliveryPickup, 
    deliveryStairs, 
    deliveryInhome, 
    deliveryCurbside 
  }); // Debug log

  // Clear existing options
  deliverySelect.innerHTML = '';

  // Helper function to parse price from string
  function parsePrice(value) {
    if (!value || value === 'null' || value === '') return null;
    
    if (value.toLowerCase().includes('free')) {
      return 0;
    }
    
    const priceMatch = value.match(/\$?(\d+(?:\.\d{2})?)/);
    return priceMatch ? parseFloat(priceMatch[1]) : null;
  }

  // Build delivery options array
  const deliveryOptions = [];

  // Add pickup option if available
  if (deliveryPickup && deliveryPickup !== 'null' && deliveryPickup !== '') {
    const price = parsePrice(deliveryPickup);
    const safePrice = price !== null ? price : 0;
    deliveryOptions.push({
      value: safePrice,
      label: safePrice === 0 ? 'Pickup - Free' : `Pickup - $${safePrice.toFixed(2)}`,
      type: 'pickup'
    });
  }

  // Add curbside delivery option if available
  if (deliveryCurbside && deliveryCurbside !== 'null' && deliveryCurbside !== '') {
    const price = parsePrice(deliveryCurbside);
    const safePrice = price !== null ? price : 0;
    deliveryOptions.push({
      value: safePrice,
      label: safePrice === 0 ? 'Curbside - Free' : `Curbside - $${safePrice.toFixed(2)}`,
      type: 'curbside'
    });
  }

  // Add in-home delivery option if available
  if (deliveryInhome && deliveryInhome !== 'null' && deliveryInhome !== '') {
    const price = parsePrice(deliveryInhome);
    const safePrice = price !== null ? price : 0;
    deliveryOptions.push({
      value: safePrice,
      label: safePrice === 0 ? 'In-Home - Free' : `In-Home - $${safePrice.toFixed(2)}`,
      type: 'inhome'
    });
  }

  // Add stairs delivery option if available
  if (deliveryStairs && deliveryStairs !== 'null' && deliveryStairs !== '') {
    const price = parsePrice(deliveryStairs);
    const safePrice = price !== null ? price : 0;
    deliveryOptions.push({
      value: safePrice,
      label: safePrice === 0 ? 'With Stairs - Free' : `With Stairs - $${safePrice.toFixed(2)}`,
      type: 'stairs'
    });
  }

  // Add default pickup option if no options are available
  if (deliveryOptions.length === 0) {
    deliveryOptions.push({
      value: 0,
      label: 'Pickup - Free',
      type: 'pickup'
    });
  }

  // Sort options by price (free options first, then by ascending price)
  deliveryOptions.sort((a, b) => {
    if (a.value === 0 && b.value !== 0) return -1;
    if (a.value !== 0 && b.value === 0) return 1;
    return a.value - b.value;
  });

  // Update the delivery item header with starting price
  const infoText = deliveryItem.querySelector('.info-text');
  if (infoText) {
    const startingPrice = parsePrice(deliveryStartingAt);
    if (startingPrice !== null && startingPrice > 0) {
      infoText.textContent = `Professional Installation: (Starting at $${startingPrice.toFixed(2)})`;
    } else {
      infoText.textContent = 'Professional Installation:';
    }
  }

  // Populate the select dropdown with installation options
  deliveryOptions.forEach((option, index) => {
    const optionElement = document.createElement('option');
    optionElement.value = option.value;
    optionElement.textContent = option.label;
    optionElement.dataset.type = option.type;
    
    // Select the first option by default
    if (index === 0) {
      optionElement.selected = true;
      selectedDelivery = option.value;
    }
    
    deliverySelect.appendChild(optionElement);
  });

  // Update the price display after changing delivery options
  updatePriceDisplay();
  
}

  // Function to fetch variant metafields via AJAX
  async function fetchVariantMetafields(variantId) {
    try {
      const response = await fetch(`/products/${productData.handle}.js`);
      const productJson = await response.json();
      
      // Find the specific variant in the response
      const variant = productJson.variants.find(v => v.id === variantId);
      
      if (variant) {
        // Shopify doesn't include metafields in the .js endpoint, so let's try a different approach
        // We'll use the variant ID to construct a URL that gives us metafields
        const metafieldResponse = await fetch(`/variants/${variantId}.json`);
        
        if (metafieldResponse.ok) {
          const variantData = await metafieldResponse.json();
          return variantData.variant;
        } else {
          // If that doesn't work, let's try using the Admin API format
          throw new Error('Metafields not available via standard endpoint');
        }
      }
      
      return variant || {};
    } catch (error) {
      console.error('Error fetching variant data:', error);
      
      // Alternative approach: check if metafields are embedded in the page
      const variantElement = document.querySelector(`[data-variant-id="${variantId}"]`);
      if (variantElement) {
        const gunCapacity = variantElement.dataset.gunCapacity;
        const weight = variantElement.dataset.weight;
        
        return {
          metafields: {
            custom: {
              variant_gun_capacity: gunCapacity,
              weight: weight
            }
          }
        };
      }
      
      return {};
    }
  }

  // Setup event listeners
  sizeOptions.forEach(option => {
    option.addEventListener('click', function(e) {
      console.log('Event details:', {
        target: e.target,
        currentTarget: e.currentTarget,
        dataset: this.dataset,
        className: this.className,
        isMobile: isMobileDevice()
      });
      
      // Ensure we're not clicking on the expand icon
      if (e.target.closest('.expand-icon')) {
        return;
      }
      
      sizeOptions.forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');
      selectedSize = this.dataset.size;
      
      // Update selection displays
      updateSelectionDisplays();
      
      // Update variant using Shopify's standard method
      updateSelectedVariant();
    });
    
    // Add touch event for better mobile responsiveness
    option.addEventListener('touchend', function(e) {
      console.log('=== SIZE OPTION TOUCHED ===');
      
      // Ensure we're not touching the expand icon
      if (e.target.closest('.expand-icon')) {
        console.log('Touch was on expand icon, ignoring size selection');
        return;
      }
      
      // Prevent the click event from firing after touchend
      e.preventDefault();
      
      // Manually trigger the selection logic
      sizeOptions.forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');
      selectedSize = this.dataset.size;
      console.log('Size selected via touch:', selectedSize);
      
      // Update selection displays
      updateSelectionDisplays();
      
      // Update variant using Shopify's standard method
      updateSelectedVariant();
    });
  });

  colorCircles.forEach(circle => {
    circle.addEventListener('click', function() {
      colorCircles.forEach(c => c.classList.remove('active'));
      this.classList.add('active');
      selectedColor = this.dataset.color;
      console.log('Color selected:', selectedColor);
      
      // Update selection displays
      updateSelectionDisplays();
      
      // Update variant using Shopify's standard method
      updateSelectedVariant();
    });
  });

  lockOptions.forEach(option => {
    option.addEventListener('click', function() {
      lockOptions.forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');
      selectedLock = this.dataset.lock;
      console.log('Lock selected:', selectedLock);
      
      // Update selection displays
      updateSelectionDisplays();
      
      // Update variant using Shopify's standard method
      updateSelectedVariant();
    });
  });

  // Upgrade options event listeners (for both color and lock upgrade sections)
  const upgradeOptions = document.querySelectorAll('.upgrade-option');
  upgradeOptions.forEach(option => {
    // Handle close button clicks separately to prevent event bubbling
    const closeBtn = option.querySelector('.close-btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Remove active state from this upgrade option
        option.classList.remove('active');

        // Clear the selected upgrade
        selectedUpgrade = null;

        // Update selection displays
        updateSelectionDisplays();

        // Update variant using Shopify's standard method
        updateSelectedVariant();

        console.log('Upgrade deselected via close button');
      });
    }

    // Handle main upgrade option selection (excluding close button)
    option.addEventListener('click', function(e) {
      // Don't trigger selection if clicking on close button
      if (e.target.closest('.close-btn')) {
        return;
      }

      // Remove active from all upgrade options in the same section
      const parentSection = this.closest('.upgrade-picker');
      const sectionUpgradeOptions = parentSection.querySelectorAll('.upgrade-option');
      sectionUpgradeOptions.forEach(opt => opt.classList.remove('active'));

      this.classList.add('active');

      // Use the full upgrade text for processing, but store display text for UI
      const fullUpgradeText = this.dataset.upgrade;
      const displayText = this.dataset.displayText || fullUpgradeText;

      selectedUpgrade = fullUpgradeText; // Keep full text for variant matching
      console.log('Upgrade selected:', selectedUpgrade, 'Display:', displayText);

      // Update selection displays
      updateSelectionDisplays();

      // Update the appropriate option based on the upgrade location
      if (parentSection.id === 'upgradeOptions') {
        // This is color section upgrade
        selectedColor = selectedUpgrade;
      } else if (parentSection.classList.contains('lock-upgrade')) {
        // This is lock section upgrade
        selectedLock = selectedUpgrade;
      }

      // Update variant using Shopify's standard method
      updateSelectedVariant();
    });
  });

  // Delivery selection event listener
  if (deliverySelect) {
    deliverySelect.addEventListener('change', function() {
      selectedDelivery = parseInt(this.value);
      console.log('Delivery selected:', selectedDelivery); // Debug log
      
      // Update cart properties and price display
      updateCartProperties();
      updatePriceDisplay();
    });
  }

  // New delivery selection event listener for order summary section
  const deliverySelectNew = document.getElementById('deliverySelectNew');
  if (deliverySelectNew) {
    deliverySelectNew.addEventListener('change', function() {
      selectedDelivery = parseInt(this.value);
      console.log('New delivery selected:', selectedDelivery); // Debug log
      
      // Update cart properties and price display
      updateCartProperties();
      updatePriceDisplay();
    });
  }

  // Initialize with current selections
  const activeSize = document.querySelector('.size-option.active');
  const activeColor = document.querySelector('.color-circle.active');
  const activeLock = document.querySelector('.lock-option.active');
  const activeUpgrade = document.querySelector('.upgrade-option.active');
  
  if (activeSize) selectedSize = activeSize.dataset.size;
  if (activeColor) selectedColor = activeColor.dataset.color;
  if (activeLock) selectedLock = activeLock.dataset.lock;
  if (activeUpgrade) selectedUpgrade = activeUpgrade.dataset.upgrade;
  
  console.log('Initialized selections:', {
    size: selectedSize,
    color: selectedColor,
    lock: selectedLock,
    upgrade: selectedUpgrade
  });
  
  // Make functions globally accessible for inline JavaScript
  window.updateSelectedVariant = updateSelectedVariant;
  window.updateMainGalleryImageShopifyWay = updateMainGalleryImageShopifyWay;
  window.findMatchingVariant = findMatchingVariant;
  window.calculateTotalPrice = calculateTotalPrice;
  window.updateCartProperties = updateCartProperties;
  window.selectedSize = selectedSize;
  window.selectedColor = selectedColor;
  window.selectedLock = selectedLock;
  window.selectedUpgrade = selectedUpgrade;
  
  // Debug function to test pricing
  window.debugPricing = function() {
    console.log('=== PRICING DEBUG ===');
    console.log('Current selections:', {
      size: selectedSize,
      color: selectedColor,
      upgrade: selectedUpgrade,
      lock: selectedLock
    });
    
    const variant = findMatchingVariant();
    console.log('Found variant:', variant);
    
    if (variant) {
      const totalPrice = calculateTotalPrice(variant);
      console.log('Calculated total price:', formatMoney(totalPrice));
      
      // Check cart properties
      const properties = {
        size: document.getElementById('selectedSizeProperty')?.value,
        color: document.getElementById('selectedColorProperty')?.value,
        lock: document.getElementById('selectedLockProperty')?.value,
        upgrade: document.getElementById('selectedUpgradeProperty')?.value,
        totalPrice: document.getElementById('totalPriceProperty')?.value,
        installation: ''  // Removed installation pricing
      };
      console.log('Cart properties:', properties);
    } else {
      console.log('No variant found for current selections');
    }
    
    // Test upgrade cost extraction
    if (selectedUpgrade) {
      const upgradeCost = extractUpgradeCost(selectedUpgrade);
      console.log('Upgrade cost:', formatMoney(upgradeCost));
    }
    
    // Test lock cost extraction
    if (selectedLock) {
      const lockCost = extractPriceFromOption(selectedLock);
      console.log('Lock cost:', formatMoney(lockCost));
    }
    
    // Show all variants for current size
    if (selectedSize && productData.variants) {
      const sizeVariants = productData.variants.filter(v => v.option1 === selectedSize);
      console.log('All variants for size ' + selectedSize + ':');
      sizeVariants.forEach(v => {
        console.log(`- ${v.id}: ${formatMoney(v.price)} | "${v.option2}" / "${v.option3}"`);
      });
    }
    
    console.log('=== END DEBUG ===');
  };
  
  // Debug function to analyze product structure
  window.debugProductStructure = function() {
    console.log('=== PRODUCT STRUCTURE DEBUG ===');
    if (productData && productData.variants) {
      console.log('Total variants:', productData.variants.length);
      
      // Group by size
      const sizeGroups = {};
      productData.variants.forEach(variant => {
        const size = variant.option1;
        if (!sizeGroups[size]) sizeGroups[size] = [];
        sizeGroups[size].push(variant);
      });
      
      Object.keys(sizeGroups).forEach(size => {
        console.log(`\nSize: ${size} (${sizeGroups[size].length} variants)`);
        sizeGroups[size].forEach(variant => {
          console.log(`  ${variant.id}: ${formatMoney(variant.price)} | "${variant.option2}" / "${variant.option3}"`);
        });
      });
    }
    console.log('=== END STRUCTURE DEBUG ===');
  };

  // Debug function to test cart functionality
  window.debugCartIssue = function() {
    console.log('=== CART ISSUE DEBUG ===');
    
    // Check current selections
    const variant = findMatchingVariant();
    console.log('Current variant:', variant);
    
    if (variant) {
      console.log('Variant details:', {
        id: variant.id,
        price: variant.price,
        available: variant.available,
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3
      });
      
      // Check form inputs
      const formInputs = {
        variantId: document.getElementById('variantId')?.value,
        quantity: document.querySelector('input[name="quantity"]')?.value,
        size: document.getElementById('selectedSizeProperty')?.value,
        color: document.getElementById('selectedColorProperty')?.value,
        lock: document.getElementById('selectedLockProperty')?.value,
        upgrade: document.getElementById('selectedUpgradeProperty')?.value
      };
      console.log('Form inputs:', formInputs);
      
      // Test if variant exists in Shopify's variant array
      const shopifyVariant = productData.variants.find(v => v.id === variant.id);
      console.log('Variant exists in product data:', !!shopifyVariant);
      
      if (!shopifyVariant) {
        console.error('CRITICAL: Selected variant does not exist in product variants!');
      }
      
      // Check if price is valid
      if (variant.price === 0 || variant.price === null || variant.price === undefined) {
        console.error('CRITICAL: Variant has invalid price:', variant.price);
      }
      
    } else {
      console.error('No variant found for current selections');
    }
    
    console.log('=== END CART DEBUG ===');
  };
  
  // Initialize order summary with current state
  const currentVariant = findMatchingVariant();
  if (currentVariant) {
    const totalPrice = calculateTotalPrice(currentVariant);
    updateOrderSummary(currentVariant, totalPrice);
    updateStickyCart(totalPrice);
  }
  
  // Add form submit event listener to ensure properties are up-to-date
  const productForm = document.getElementById('productForm');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      // Update cart properties one more time before submission
      updateCartProperties();
      
      console.log('Form submitting with properties:', {
        variantId: document.getElementById('variantId')?.value,
        quantity: document.querySelector('input[name="quantity"]')?.value,
        note: 'Cart properties temporarily disabled for testing'
      });
      
      // Allow normal form submission
      return true;
    });
  }
  
  updateSelectedVariant();
  
  // Initialize selection displays
  updateSelectionDisplays();
  
  // Initialize cart properties
  updateCartProperties();

  // Initialize desktop swipe for thumbnails
  initializeDesktopSwipe();

  // Desktop swipe functionality for thumbnail gallery
  function initializeDesktopSwipe() {
    const thumbnailContainer = document.querySelector('.product-gallery__thumbnails');
    const mainGallery = document.querySelector('.product-gallery__main');
    
    if (!thumbnailContainer && !mainGallery) {
      console.log('No swipeable galleries found');
      return;
    }

    // Enhanced desktop navigation that works with Flickity
    function addEnhancedNavigation() {
      const galleryMain = document.querySelector('.product-gallery__main');
      const thumbnailGallery = document.querySelector('.product-gallery__thumbnails');
      
      if (!galleryMain) {
        console.log('No gallery main found');
        return;
      }

      // Wait for Flickity to initialize, then enhance
      function initializeWhenReady() {
        setTimeout(() => {
          const flickityElement = document.querySelector('.product-gallery__main.flickity-enabled');
          
          if (flickityElement) {
            console.log('Flickity detected, adding enhanced navigation');
            addFlickityNavigation(flickityElement);
          } else {
            console.log('Flickity not ready, checking again...');
            initializeWhenReady();
          }
        }, 300);
      }

      initializeWhenReady();
    }

    function addFlickityNavigation(flickityElement) {
      let flickityInstance = null;

      // Get Flickity instance
      function getFlickityInstance() {
        if (flickityInstance) return flickityInstance;
        
        // Try multiple ways to get Flickity instance
        if (flickityElement.flickity) {
          flickityInstance = flickityElement.flickity;
        } else if (window.$ && window.$(flickityElement).data('flickity')) {
          flickityInstance = window.$(flickityElement).data('flickity');
        } else if (window.Flickity && window.Flickity.data) {
          flickityInstance = window.Flickity.data(flickityElement);
        }
        
        return flickityInstance;
      }

      // Keyboard navigation
      document.addEventListener('keydown', function(e) {
        // Only work if no input is focused
        const focusedElement = document.activeElement;
        const isInputFocused = focusedElement && (
          focusedElement.tagName === 'INPUT' || 
          focusedElement.tagName === 'TEXTAREA' || 
          focusedElement.tagName === 'SELECT' ||
          focusedElement.contentEditable === 'true'
        );
        
        if (isInputFocused) return;
        
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          const flkty = getFlickityInstance();
          if (flkty) {
            if (e.key === 'ArrowLeft') {
              flkty.previous();
            } else {
              flkty.next();
            }
            console.log('Keyboard navigation:', e.key === 'ArrowLeft' ? 'prev' : 'next');
          }
        }
      });

      // Mouse wheel navigation
      const galleryArea = document.querySelector('.product-gallery');
      if (galleryArea) {
        let wheelTimeout;
        
        galleryArea.addEventListener('wheel', function(e) {
          // Only handle horizontal wheel events or shift+wheel
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey) {
            e.preventDefault();
            
            clearTimeout(wheelTimeout);
            wheelTimeout = setTimeout(() => {
              const flkty = getFlickityInstance();
              if (flkty) {
                const delta = e.deltaX || e.deltaY;
                if (Math.abs(delta) > 10) { // Minimum threshold
                  if (delta > 0) {
                    flkty.next();
                  } else {
                    flkty.previous();
                  }
                  console.log('Wheel navigation:', delta > 0 ? 'next' : 'prev');
                }
              }
            }, 50);
          }
        }, { passive: false });
      }

      // Enhanced drag behavior - let Flickity handle the actual dragging
      // but add visual feedback
      flickityElement.addEventListener('mouseenter', function() {
        if (!flickityElement.classList.contains('is-pointer-down')) {
          flickityElement.style.cursor = 'grab';
        }
      });

      flickityElement.addEventListener('mouseleave', function() {
        if (!flickityElement.classList.contains('is-pointer-down')) {
          flickityElement.style.cursor = '';
        }
      });

      // Update cursor during drag
      flickityElement.addEventListener('pointerDown', function() {
        flickityElement.style.cursor = 'grabbing';
      });

      document.addEventListener('pointerup', function() {
        if (flickityElement.style.cursor === 'grabbing') {
          flickityElement.style.cursor = 'grab';
        }
      });

      // Add visual hint for navigation
      addNavigationHint(flickityElement);

      function addNavigationHint(galleryElement) {
        // Don't add hint if one already exists
        if (document.querySelector('.gallery-navigation-hint')) return;

        const hint = document.createElement('div');
        hint.className = 'gallery-navigation-hint';
        hint.innerHTML = `
          <div class="hint-content">
            <span>💡 Navigate: Arrow keys, Mouse wheel (shift+scroll), or drag</span>
          </div>
        `;
        hint.style.cssText = `
          position: absolute;
          top: 15px;
          right: 15px;
          background: rgba(0,0,0,0.85);
          color: white;
          padding: 10px 14px;
          border-radius: 8px;
          font-size: 12px;
          z-index: 100;
          opacity: 0.9;
          pointer-events: none;
          transition: opacity 0.3s ease;
          font-family: -apple-system, BlinkMacSystemFont, sans-serif;
          box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        `;
        
        const gallery = galleryElement.closest('.product-gallery');
        if (gallery) {
          gallery.style.position = 'relative';
          gallery.appendChild(hint);
          
          // Hide hint after 5 seconds
          setTimeout(() => {
            hint.style.opacity = '0';
            setTimeout(() => hint.remove(), 500);
          }, 5000);
        }
      }

      console.log('Enhanced Flickity navigation initialized');
    }

    // Initialize the enhanced navigation
    addEnhancedNavigation();
  }

  // Debug: Log gallery setup
  console.log('Gallery elements found:', {
    mainGallery: !!mainGallery,
    mainProductImage: !!mainProductImage,
    thumbnailImages: thumbnailImages.length,
    isFlickityEnabled: mainGallery?.classList.contains('flickity-enabled')
  });
  
  // Add debugging function to window for testing
  window.debugImageSwitching = function() {
    console.log('=== IMAGE SWITCHING DEBUG ===');
    console.log('Selected options:', { selectedSize, selectedColor, selectedLock });
    
    const allImages = document.querySelectorAll('.product-gallery__main .product-gallery__image img');
    const allContainers = document.querySelectorAll('.product-gallery__main .product-gallery__image');
    
    console.log('Available images with alt text:');
    allImages.forEach((img, index) => {
      const container = allContainers[index];
      const isSelected = container?.classList.contains('is-selected');
      console.log(`${index}: Alt="${img.alt}", Selected=${isSelected}, Src="${img.src}"`);
    });
    
    const matchingImage = findImageByAltText();
    if (matchingImage) {
      console.log('Found matching image:', {
        index: matchingImage.imageIndex,
        alt: matchingImage.element.alt,
        src: matchingImage.element.src
      });
    } else {
      console.log('No matching image found');
    }
    
    // Test the switching function
    updateGalleryByAltText();
  };
  
  window.testImageSwitch = function(optionType, optionValue) {
    console.log(`Testing image switch for ${optionType}: ${optionValue}`);
    
    // Temporarily set the option
    const oldValue = window[`selected${optionType.charAt(0).toUpperCase() + optionType.slice(1)}`];
    window[`selected${optionType.charAt(0).toUpperCase() + optionType.slice(1)}`] = optionValue;
    
    // Test the switch
    updateGalleryByAltText();
    
    // Restore old value after a delay so you can see the result
    setTimeout(() => {
      window[`selected${optionType.charAt(0).toUpperCase() + optionType.slice(1)}`] = oldValue;
      console.log('Restored original value');
    }, 3000);
  };
  
  // Function to test all available image switching combinations
  window.testAllImageSwitching = function() {
    console.log('=== TESTING ALL IMAGE SWITCHING COMBINATIONS ===');
    
    // Get all available options
    const sizes = Array.from(sizeOptions).map(opt => opt.dataset.size);
    const colors = Array.from(colorCircles).map(circle => circle.dataset.color);
    const locks = Array.from(lockOptions).map(opt => opt.dataset.lock);
    
    console.log('Available options:', { sizes, colors, locks });
    
    // Test each option type with 3 second delays
    let delay = 0;
    
    if (sizes.length > 0) {
      console.log('\n--- Testing Sizes ---');
      sizes.forEach((size, index) => {
        setTimeout(() => {
          console.log(`Testing size: ${size}`);
          window.testImageSwitch('size', size);
        }, delay);
        delay += 4000;
      });
    }
    
    if (colors.length > 0) {
      console.log('\n--- Testing Colors ---');
      colors.forEach((color, index) => {
        setTimeout(() => {
          console.log(`Testing color: ${color}`);
          window.testImageSwitch('color', color);
        }, delay);
        delay += 4000;
      });
    }
    
    if (locks.length > 0) {
      console.log('\n--- Testing Locks ---');
      locks.forEach((lock, index) => {
        setTimeout(() => {
          console.log(`Testing lock: ${lock}`);
          window.testImageSwitch('lock', lock);
        }, delay);
        delay += 4000;
      });
    }
    
    // Reset to original selections after all tests
    setTimeout(() => {
      updateSelectedVariant();
      console.log('=== ALL TESTS COMPLETE - RESET TO ORIGINAL ===');
    }, delay + 1000);
  };
  
  window.analyzeVariantFormat = function() {
    console.log('Analyzing variant naming format...');
    
    if (!productData) {
      console.log('No product data available');
      return;
    }
    
    productData.variants.forEach((variant, index) => {
      console.log(`Variant ${index + 1}:`, {
        id: variant.id,
        title: variant.title,
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3,
        price: variant.price
      });
    });
  };
  
  // Function to setup alt text for images (helper for theme editor)
  window.setupImageAltText = function() {
    console.log('Setting up image alt text...');
    
    const images = document.querySelectorAll('.product__images img, .size-image, .lock-image, .color-circle');
    images.forEach((img, index) => {
      if (!img.alt || img.alt === '') {
        img.alt = `Product image ${index + 1}`;
        console.log(`Set alt text for image ${index + 1}:`, img.alt);
      }
    });
  };

  // Debug function for tooltips
  window.debugTooltips = function() {
    console.log('=== TOOLTIP DEBUG ===');
    const tooltipElements = document.querySelectorAll('[data-tooltip]');
    const tooltipDiv = document.getElementById('tooltip');
    
    console.log('Tooltip elements found:', tooltipElements.length);
    console.log('Tooltip div exists:', !!tooltipDiv);
    
    tooltipElements.forEach((el, index) => {
      console.log(`Tooltip ${index + 1}:`, el.dataset.tooltip);
    });
    
    if (tooltipElements.length > 0) {
      console.log('Testing first tooltip...');
      const firstElement = tooltipElements[0];
      firstElement.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
      
      setTimeout(() => {
        firstElement.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true }));
        console.log('Tooltip test completed');
      }, 2000);
    }
  };

  // Function to analyze variant naming format
  window.analyzeVariantFormat = function() {
    console.log('=== VARIANT FORMAT ANALYSIS ===');
    console.log('Expected format: "25 | Dimensions: 60.5"(H) x 30"(W) x 28.5"(D) / Gray Marble / Mechanical Lock"');
    console.log('');
    
    // Analyze all variants
    const allVariants = productData.variants;
    console.log('All product variants:');
    allVariants.forEach((variant, index) => {
      const title = variant.title || `${variant.option1} / ${variant.option2} / ${variant.option3}`;
      const parts = title.split(' / ');
      
      console.log(`\nVariant ${index + 1}: "${title}"`);
      console.log('  Parsed parts:', parts);
      
      if (parts.length >= 1) {
        const sizeMatch = parts[0].match(/^(\d+)/);
        console.log('  Size/Model:', parts[0], sizeMatch ? `(extracted: ${sizeMatch[1]})` : '(no number found)');
      }
      if (parts.length >= 2) {
        console.log('  Color:', parts[1]);
      }
      if (parts.length >= 3) {
        console.log('  Lock:', parts[2]);
      }
    });
    
  };
  
  // Function to setup alt text for images (helper for theme editor)
  window.setupImageAltText = function() {
    const sizes = Array.from(sizeOptions).map(opt => opt.dataset.size);
    const colors = Array.from(colorCircles).map(circle => circle.dataset.color);
    const locks = Array.from(lockOptions).map(opt => opt.dataset.lock);
    
    
    // Generate examples for complete variants
    if (sizes.length > 0 && colors.length > 0 && locks.length > 0) {
      console.log('Examples of complete variant alt text:');
      console.log(`   - "${sizes[0]} ${colors[0]} ${locks[0]}"`);
      if (sizes[1] && colors[1] && locks[1]) {
        console.log(`   - "${sizes[1]} ${colors[1]} ${locks[1]}"`);
      }
    }
  };
  
  // Re-initialize tooltips to ensure all elements have tooltips (after a short delay for dynamic content)
  setTimeout(() => {
    initTooltips();
  }, 500);
  
  // Wait a bit for size options to be ready
  setTimeout(function() {
    initializeModalSystem();
  }, 1000);
  
  // Add global debug function for testing size option clicks
  window.debugSizeOptions = function() {
    const sizeOptions = document.querySelectorAll('.size-option');
    
    sizeOptions.forEach((option, index) => {
      const computedStyle = window.getComputedStyle(option);
      console.log(`Size option ${index}:`, {
        element: option,
        dataSize: option.dataset.size,
        className: option.className,
        pointerEvents: computedStyle.pointerEvents,
        cursor: computedStyle.cursor,
        display: computedStyle.display,
        zIndex: computedStyle.zIndex,
        position: computedStyle.position
      });
      
      // Test if click works by adding a temporary listener
      const testClick = function() {
        option.removeEventListener('click', testClick);
      };
      option.addEventListener('click', testClick);
    });
    
  };
  
  // Auto-run the debug after elements are ready
  setTimeout(() => {
    console.log('Auto-running size options debug...');
    window.debugSizeOptions();
  }, 2000);
}

function initializeModalSystem() {
  // Create modal elements
  let zoomBackdrop = document.querySelector('.zoom-backdrop');
  let zoomModal = document.querySelector('.size-image-zoom');
  
  if (!zoomBackdrop) {
    zoomBackdrop = document.createElement('div');
    zoomBackdrop.className = 'zoom-backdrop';
    document.body.appendChild(zoomBackdrop);
    console.log('Created backdrop');
  }
  
  if (!zoomModal) {
    zoomModal = document.createElement('div');
    zoomModal.className = 'size-image-zoom';
    zoomModal.innerHTML = `
      <button class="close-button" type="button">✕</button>
      <img src="" alt="">
      <div class="zoom-label"></div>
    `;
    document.body.appendChild(zoomModal);
    console.log('Created modal');
  }

  const zoomImg = zoomModal.querySelector('img');
  const zoomLabel = zoomModal.querySelector('.zoom-label');
  const closeButton = zoomModal.querySelector('.close-button');

  // Find all size options
  const sizeOptions = document.querySelectorAll('.size-option');
  console.log('Found size options:', sizeOptions.length);

  sizeOptions.forEach((option, index) => {
    console.log('Processing size option', index);
    
    // Remove existing expand icon
    const existingIcon = option.querySelector('.expand-icon');
    if (existingIcon) {
      existingIcon.remove();
    }

    // Create expand icon
    const expandIcon = document.createElement('div');
    expandIcon.className = 'expand-icon';
    expandIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m15 15 6 6"/>
        <path d="m15 9 6-6"/>
        <path d="M21 16v5h-5"/>
        <path d="M21 8V3h-5"/>
        <path d="M3 16v5h5"/>
        <path d="m3 21 6-6"/>
        <path d="M3 8V3h5"/>
        <path d="M9 9 3 3"/>
      </svg>
    `;
    
    option.appendChild(expandIcon);
    console.log('Added expand icon to option', index);

    // Add click handler with mobile-friendly logic
    expandIcon.addEventListener('click', function(e) {
      console.log('=== EXPAND ICON CLICKED ===');
      console.log('Event:', e);
      
      // Always stop propagation to prevent the size option from being clicked when clicking the expand icon
      e.stopPropagation();
      
      // Check if we're on a mobile device
      const isMobile = isMobileDevice();
      
      if (isMobile) {
        // On mobile, show the modal but prevent default to avoid any unwanted behavior
        console.log('Mobile device - showing modal');
        e.preventDefault();
      } else {
        // Desktop behavior - prevent default for modal
        console.log('Desktop device - showing modal');
        e.preventDefault();
      }
      
      const image = option.querySelector('.size-image');
      console.log('Found image:', image);
      console.log('Image src:', image ? image.src : 'NO IMAGE');
      
      if (image && image.src) {
        const label = option.getAttribute('data-label') || 
                     option.getAttribute('data-size') || 
                     option.querySelector('.size-label')?.textContent || 
                     'Size Image';
        
        console.log('Opening modal with:', { src: image.src, label: label });
        
        // Set modal content
        zoomImg.src = image.src;
        zoomImg.alt = label;
        zoomLabel.textContent = label;
        
        // Show modal
        zoomBackdrop.classList.add('visible');
        zoomModal.classList.add('visible');
        document.body.style.overflow = 'hidden';
        
        console.log('Modal should now be visible');
      } else {
        console.error('No valid image found for this size option');
      }
    });

    // Also add a test click handler to the entire option for debugging
    option.addEventListener('click', function(e) {
      console.log('Size option clicked:', e.target.className);
    });
  });

  // Close modal handlers
  closeButton.addEventListener('click', function() {
    console.log('Close button clicked');
    closeModal();
  });

  zoomBackdrop.addEventListener('click', function(e) {
    if (e.target === zoomBackdrop) {
      console.log('Backdrop clicked');
      closeModal();
    }
  });

  function closeModal() {
    console.log('Closing modal');
    zoomBackdrop.classList.remove('visible');
    zoomModal.classList.remove('visible');
    document.body.style.overflow = '';
  }

  console.log('Modal system initialized successfully');
}

// Add global debug function
window.testModal = function() {
  console.log('=== MANUAL MODAL TEST ===');
  const sizeOptions = document.querySelectorAll('.size-option');
  const expandIcons = document.querySelectorAll('.expand-icon');
  
  console.log('Size options found:', sizeOptions.length);
  console.log('Expand icons found:', expandIcons.length);
  
  sizeOptions.forEach((option, index) => {
    const image = option.querySelector('.size-image');
    const expandIcon = option.querySelector('.expand-icon');
    console.log(`Option ${index}:`, {
      hasImage: !!image,
      hasExpandIcon: !!expandIcon,
      imageSrc: image ? image.src : 'none'
    });
  });
  
  // Try to manually trigger the first expand icon
  const firstIcon = document.querySelector('.expand-icon');
  if (firstIcon) {
    console.log('Manually clicking first expand icon...');
    firstIcon.click();
  } else {
    console.log('No expand icons found to test');
  }
};

// Debug function to help troubleshoot gallery issues
window.debugGalleryUpdate = function() {
  console.log('=== GALLERY DEBUG INFO ===');
  
  // Check gallery structure
  const galleryMain = document.querySelector('.product-gallery__main');
  const flickitySlider = document.querySelector('.flickity-slider');
  const galleryImages = document.querySelectorAll('.product-gallery__main .product-gallery__image');
  const selectedImage = document.querySelector('.product-gallery__main .product-gallery__image.is-selected img');
  const firstGalleryImage = document.querySelector('.product-gallery__main .product-gallery__image:first-child img');
  const thumbnails = document.querySelectorAll('.product-gallery__thumbnails .product-gallery__thumbnail');
  const firstThumbnail = document.querySelector('.product-gallery__thumbnails .product-gallery__thumbnail:first-child img');
  
  console.log('Gallery Main Container:', galleryMain);
  console.log('Flickity Slider:', flickitySlider);
  console.log('Gallery Images Count:', galleryImages.length);
  console.log('Currently Selected Image:', selectedImage);
  console.log('First Gallery Image:', firstGalleryImage);
  console.log('Thumbnails Count:', thumbnails.length);
  console.log('First Thumbnail:', firstThumbnail);
  
  // Check which images have is-selected class
  galleryImages.forEach((img, index) => {
    const isSelected = img.classList.contains('is-selected');
    const transform = img.style.transform;
    const imgElement = img.querySelector('img');
    console.log(`Image ${index}:`, {
      isSelected,
      transform,
      src: imgElement ? imgElement.src : 'no img',
      id: imgElement ? imgElement.id : 'no id'
    });
  });
  
  if (selectedImage) {
    console.log('Selected Image Details:', {
      src: selectedImage.src,
      alt: selectedImage.alt,
      id: selectedImage.id,
      dataSrc: selectedImage.dataset.src,
      dataZoomSrc: selectedImage.dataset.zoomSrc
    });
  }
  
  if (firstThumbnail) {
    console.log('Thumbnail Details:', {
      src: firstThumbnail.src,
      alt: firstThumbnail.alt
    });
  }
  
  // Check Flickity status
  const flickityElement = document.querySelector('.product-gallery__main.flickity-enabled');
  if (flickityElement && typeof Flickity !== 'undefined') {
    const flkty = Flickity.data(flickityElement);
    console.log('Flickity Instance:', flkty);
    if (flkty) {
      console.log('Flickity Selected Index:', flkty.selectedIndex);
      console.log('Flickity Cells Count:', flkty.cells.length);
    }
  }
  
  // Test updating the selected image manually
  console.log('=== TESTING MANUAL UPDATE ===');
  if (selectedImage) {
    const testUrl = 'https://via.placeholder.com/800x800/ff0000/ffffff?text=TEST';
    console.log('Setting test image on selected image:', testUrl);
    selectedImage.src = testUrl;
    
    setTimeout(() => {
      console.log('Selected image src after update:', selectedImage.src);
    }, 1000);
  } else if (firstGalleryImage) {
    const testUrl = 'https://via.placeholder.com/800x800/00ff00/000000?text=FIRST';
    console.log('Setting test image on first image:', testUrl);
    firstGalleryImage.src = testUrl;
    
    setTimeout(() => {
      console.log('First image src after update:', firstGalleryImage.src);
    }, 1000);
  }
  
  // Check product data
  const productJsonElement = document.getElementById('product-json');
  if (productJsonElement) {
    try {
      const productData = JSON.parse(productJsonElement.textContent);
      console.log('Product variants with images:', 
        productData.variants.filter(v => v.featured_image).map(v => ({
          id: v.id,
          title: v.title,
          image_id: v.featured_image?.id,
          image_src: v.featured_image?.src
        }))
      );
    } catch (e) {
      console.error('Error parsing product data:', e);
    }
  }
};

// Test function to manually trigger updateProductImage
window.testGalleryUpdate = function(variantId) {
  console.log('=== TESTING GALLERY UPDATE ===');
  
  const productJsonElement = document.getElementById('product-json');
  if (!productJsonElement) {
    console.error('Product data not found');
    return;
  }
  
  try {
    const productData = JSON.parse(productJsonElement.textContent);
    const variant = productData.variants.find(v => v.id == variantId) || productData.variants[0];
    
    if (variant && variant.featured_image) {
      console.log('Testing with variant:', variant.title, 'Image:', variant.featured_image.src);
      
      // Call the updateProductImage function directly
      const newImageUrl = variant.featured_image.src;
      const newImageAlt = variant.featured_image.alt || variant.name || productData.title;
      const cleanImageUrl = newImageUrl.includes('?') ? newImageUrl.split('?')[0] : newImageUrl;
      
      // Find and update the main image
      const firstGalleryImage = document.querySelector('.product-gallery__main .product-gallery__image:first-child img');
      if (firstGalleryImage) {
        const mainImageUrl = cleanImageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_1200x.$1');
        console.log('Updating main image to:', mainImageUrl);
        firstGalleryImage.src = mainImageUrl + '?v=' + Date.now();
        firstGalleryImage.alt = newImageAlt;
      } else {
        console.error('Could not find main gallery image');
      }
      
      // Update thumbnail
      const firstThumbnail = document.querySelector('.product-gallery__thumbnails .product-gallery__thumbnail:first-child img');
      if (firstThumbnail) {
        const thumbUrl = cleanImageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_300x.$1');
        console.log('Updating thumbnail to:', thumbUrl);
        firstThumbnail.src = thumbUrl + '?v=' + Date.now();
        firstThumbnail.alt = newImageAlt;
      } else {
        console.error('Could not find thumbnail image');
      }
    } else {
      console.error('Variant not found or has no featured image');
    }
  } catch (e) {
    console.error('Error testing gallery update:', e);
  }
};

// Debug functions for testing gallery integration
window.testGalleryIntegration = function() {
  console.log('=== Gallery Integration Test ===');
  
  // Check if required elements exist
  const galleryMain = document.querySelector('.product-gallery__main');
  const variantScript = document.getElementById('variant-images-' + (productData ? productData.id : 'unknown'));
  const sectionScript = document.querySelector('[data-section-data]');
  
  console.log('Gallery main element:', galleryMain ? 'Found' : 'Missing');
  console.log('Variant images script:', variantScript ? 'Found' : 'Missing');
  console.log('Section data script:', sectionScript ? 'Found' : 'Missing');
  
  if (productData) {
    console.log('Product data loaded:', productData.title);
    console.log('Available variants:', productData.variants.length);
    
    // Test with first variant
    const firstVariant = productData.variants[0];
    if (firstVariant) {
      console.log('Testing with first variant:', firstVariant.id);
      console.log('Variant featured_media:', firstVariant.featured_media);
      console.log('Variant featured_image:', firstVariant.featured_image);
      
      // Test Shopify's method directly
      updateMainGalleryImageShopifyWay(firstVariant);
    }
  } else {
    console.log('Product data not available');
  }
  
  console.log('=== End Test ===');
};

window.testVariantSelection = function(size, color, lock) {
  console.log('Testing variant selection:', { size, color, lock });
  
  // Update selections
  if (size) selectedSize = size;
  if (color) selectedColor = color; 
  if (lock) selectedLock = lock;
  
  // Trigger update
  updateSelectedVariant();
  
  // Show what variant was found
  const variant = findMatchingVariant();
  if (variant) {
    console.log('Found variant:', variant.id, variant.title);
  } else {
    console.log('No matching variant found for selections:', { selectedSize, selectedColor, selectedLock });
  }
};

  // Function to add main product + upgrades to cart as separate line items
  async function addToCartWithUpgrades() {
    const variant = findMatchingVariant();
    if (!variant) {
      alert('Please select all options');
      return;
    }
    
    // Disable the button during processing
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding to Cart...';
    
    try {
      const cartItems = [];
      
      // 1. Main product item
      const mainItem = {
        id: variant.id,
        quantity: 1,
        properties: {
          'Selected Size': selectedSize || '',
          'Selected Color': selectedColor || '',
          'Selected Lock': selectedLock || '',
          'Selected Upgrade': selectedUpgrade || ''
          // Removed Total Price property - pricing should come from variant
        }
      };
      cartItems.push(mainItem);
      
      // 2. Create hidden upgrade items if needed
      if (selectedLock && selectedLock !== 'No Lock Upgrade') {
        const lockCost = extractPriceFromOption(selectedLock);
        if (lockCost > 0) {
          // You'll need to create a hidden product for lock upgrades in Shopify admin
          // For now, we'll add it as a line item property and adjust the main item price
          console.log('Lock upgrade cost:', lockCost);
        }
      }
      
      if (selectedUpgrade && selectedUpgrade !== 'No Upgrade') {
        const upgradeCost = extractUpgradeCost(selectedUpgrade);
        if (upgradeCost > 0) {
          // You'll need to create a hidden product for upgrades in Shopify admin
          // For now, we'll add it as a line item property and adjust the main item price
          console.log('Upgrade cost:', upgradeCost);
        }
      }
      
      if (selectedDelivery > 0) {
        // Delivery functionality is commented out
        console.log('Delivery cost (not included):', selectedDelivery);
      }
      
      // Add items to cart using AJAX
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: cartItems
        })
      });
      
      if (response.ok) {
        console.log('Successfully added to cart');
        
        // Update cart count and redirect to cart or show success message
        updateCartCount();
        
        // Redirect to cart page or show success message
        if (window.location.pathname !== '/cart') {
          window.location.href = '/cart';
        } else {
          // If already on cart page, reload it
          window.location.reload();
        }
      } else {
        throw new Error('Failed to add to cart');
      }
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding to cart. Please try again.');
    } finally {
      // Re-enable the button
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to Cart - ' + formatMoney(calculateTotalPrice(variant));
    }
  }
  
  // Helper function to update cart count in header
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count in header (adjust selector as needed)
        const cartCountElements = document.querySelectorAll('.cart-count, .cart__item-count, [data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
      })
      .catch(error => {
        console.warn('Could not update cart count:', error);
      });
  }

// ─── Product Intro Block ───────────────────────────────────────────────────
// Parses the mothers_day_product_specs metafield (passed via data-intro attr)
// and splits it into a prose section and a structured "Configuration Details"
// spec grid.

document.addEventListener('DOMContentLoaded', function initProductIntroBlocks() {
  function escapeHTML(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  document.querySelectorAll('.product-intro-block[data-intro]').forEach(function(block) {
    var raw = block.dataset.intro;
    if (!raw) return;

    var lines = raw.split(/\r?\n/);
    var titleEl = block.querySelector('.intro-section-title');
    var specsSection = block.querySelector('.intro-specs-section');
    var specsGrid = block.querySelector('.intro-specs-grid');

    var sectionTitle = '';
    var specsHTML = '';

    for (var i = 0; i < lines.length; i++) {
      var rawLine = lines[i];
      var line = rawLine.trim();

      if (!line) continue;

      // Skip indented continuation lines (handled via lookahead below)
      if (rawLine !== rawLine.trimStart()) continue;

      // Section header: ends with ":" and has no ": " — e.g. "How this Maverick is configured:"
      if (line.endsWith(':') && line.indexOf(': ') === -1) {
        sectionTitle = line;
        continue;
      }

      // Spec line: "Key: Value" where key is ≤ 35 chars
      var colonIdx = line.indexOf(': ');
      if (colonIdx > 0 && colonIdx <= 35) {
        var key = line.substring(0, colonIdx);
        var value = line.substring(colonIdx + 2);

        // Lookahead: join an indented continuation on the very next line
        if (i + 1 < lines.length) {
          var nextRaw = lines[i + 1];
          var nextTrimmed = nextRaw.trim();
          if (nextTrimmed && nextRaw !== nextRaw.trimStart()) {
            value += ' ' + nextTrimmed;
          }
        }

        specsHTML +=
          '<div class="intro-spec-row">' +
            '<dt class="intro-spec-key">' + escapeHTML(key) + '</dt>' +
            '<dd class="intro-spec-value">' + escapeHTML(value) + '</dd>' +
          '</div>';
      }
      // Prose lines are intentionally skipped — only config title + specs are shown
    }

    if (titleEl && sectionTitle) {
      titleEl.textContent = sectionTitle;
      titleEl.style.display = '';
    }

    if (specsSection && specsGrid && specsHTML) {
      specsGrid.innerHTML = specsHTML;
      specsSection.style.display = '';
    }
  });
});

